import React, { useState, useEffect } from "react";
import { UploadOutlined } from "@ant-design/icons";
import {
  Form,
  Input,
  Upload,
  Select,
  Modal,
  Button,
  Space,
  Row,
  Col,
  DatePicker,
  Table,
  InputNumber,
  Tooltip,
  Divider,
  Collapse,
  TimePicker,
  Switch,
} from "antd";
import {
  MinusCircleOutlined, PlusOutlined, CaretUpOutlined,    // ✅ Add this
  CaretDownOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";
import { apiRequest } from "../../../../service/apiRequest";
import { showSuccess, showError } from "../../../../components/errorHandler";
// import type {
//     CompanyName,
// } from '../../../../types/CompanyName';
import type { UploadFile } from 'antd/es/upload/interface';
import type {
  Pn,
  Categories,
  BrandNames,
} from "../../../../types/CreateProductType";

import type { SelectProps } from 'antd';

import type { ColumnsType } from 'antd/es/table';

import duration from 'dayjs/plugin/duration';
import { Dayjs } from "dayjs";

import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const { Option } = Select;

const { Panel } = Collapse;

const MSME_REGEX = /^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/;


const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY'];


const { TextArea } = Input;
dayjs.extend(duration);

interface AccountHead {
  ah_id: number;
  ah_name: string;
  ah_parent: number;

}
interface SubHead {
  ah_id: number;
  ah_name: string;
}
interface LinkItem {
  link: string;
  description?: string;
  link_name?: string;
  link_url?: string;
}
interface BankItem {
  bank_name: string;
  ifsc: string;
  acc_no: string;
  address?: string;
  holder_name?: string;
  bank_account_account_no?: string;
  bank_account_bank_address?: string;
  bank_account_branch_name?: string;
  bank_account_holder_name?: string;
  bank_account_ifsc?: string;
}
interface AddressItem {
  type?: "residence" | "office";
  address?: string;
  landmark?: string;
  pincode?: string;
  city?: string;
  state?: string;
  country?: string;
  address_type?: "residence" | "office";
  address_detail?: string;
  address_landmark?: string;
  address_pincode?: string;
  address_city?: string;
  address_state?: string;
  address_country?: string;
}

interface PayrollItem {
  payroll_id?: number;
  payroll_ledger_id?: number;

  payroll_check_in?: string | Dayjs | null;
  payroll_check_out?: string | Dayjs | null;
  payroll_working_hours?: string;
  payroll_lunch_in?: string | Dayjs | null;
  payroll_lunch_out?: string | Dayjs | null;
  payroll_days_of_working?: string | string[] | null | undefined;
  payroll_days_off?: string | string[] | null | undefined;
  payroll_date_of_joining?: string | Dayjs | null;

  payroll_salary?: number | null;

  payroll_type_of_work?: string;
  payroll_increment_period?: string;
  payroll_increment_type?: string;
  payroll_increment_value?: number;

  payroll_late_allowance_time?: string | Dayjs | null;
  payroll_late_apply_half_day?: boolean | null;
  payroll_late_deduct_commission?: boolean | null;

  payroll_late_commission_percentage?: number | null;

  payroll_early_go_allowance_time?: string | Dayjs | null;
  payroll_early_apply_half_day?: boolean | null;
  payroll_early_deduct_commission?: boolean | null;
  payroll_early_commission_percentage?: number | null;
}
interface PhoneItem {
  first_name?: string;
  last_name?: string;
  label?: string;
  number?: string;
  designation?: string;
  email?: string;
  std_phone?: string;
  type?: string;
  std_code?: string;
  sms?: "Yes" | "No";
  contact_first_name?: string;
  contact_last_name?: string;
  contact_label?: string;
  contact_number?: string;
  contact_designation?: string;
  contact_email?: string;
  contact_type?: string;
  contact_std_phone?: string;
  contact_std_code?: string;
  contact_sms?: "Yes" | "No";
}
interface CategoryItem {
  category_id?: number;
  discount?: number;
  special_discount?: number;
  lcm_category_id?: number;
  lcm_discount?: number;
  lcm_special_discount?: number;
}
interface CategoryWithDiscount extends Categories {
  discount: number;
  special_discount: number;
  lcm_id?: number | null;
}

interface DocumentItem {
  document_id?: number;
  document_type: string;
  document_name: string;
  attachments: string;
}

interface LedgerFormValues {
  ledger_first_name: string;
  ledger_last_name?: string;
  ledger_account_head?: number;
  ledger_sub_account_head?: number;
  ledger_mobile_no?: string;
  ledger_company_name?: string;
  ledger_occupation?: string;
  ledger_designation?: string;
  ledger_opening_balance?: number;
  ledger_opening_type?: string;
  ledger_email?: string;
  ledger_gst_type?: string;
  ledger_gstin?: string;
  ledger_pan_no?: string;
  ledger_cin_no?: string;
  ledger_tin_no?: string;
  ledger_msme_reg_no?: string;
  ledger_bill_to_bill?: 'Yes' | 'No';
  ledger_reserve_fund?: string;
  ledger_tds?: string;
  ledger_deals_in_company?: string[];
  ledger_deals_in_product?: string[];
  ledger_interest_rate?: number;
  ledger_interest_style?: string;
  ledger_credit_limit_day?: number;
  ledger_credit_limit_amount?: number;
  ledger_dob?: dayjs.Dayjs | null;
  ledger_marriage_anniversary?: dayjs.Dayjs | null;
  ledger_work_anniversary?: dayjs.Dayjs | null;
  ledger_offer_festival?: string;
  ledger_status?: number;
  ledger_image?: string;
  links?: LinkItem[];
  banks?: BankItem[];
  addresses?: AddressItem[];
  payrolls?: PayrollItem[];
  phones?: PhoneItem[];
  categories?: CategoryItem[];
  documents?: DocumentItem[];
  payroll_working_hours?: string;
}


const occupations: string[] = [
  "Textile Merchant",
  "Fabric Shop Owner",
  "Tailor",
  "Fashion Designer",
  "Garment Worker",
  "Textile Designer",
  "Embroidery Specialist",
  "Boutique Owner",
  "Clothing Retailer",
  "Apparel Sales Associate",
  "Sewing Machine Operator",
  "Clothing Store Manager",
  "Alteration Specialist",
  "Software Engineer",
  "Data Scientist",
  "Product Manager",
  "Accountant",
  "Marketing Manager",
  "Sales Executive",
  "HR Manager",
  "Doctor",
  "Nurse",
  "Teacher",
  "Graphic Designer",
  "Photographer",
  "Lawyer",
  "Police Officer",
  "Electrician",
  "Mechanic",
  "Pilot",
  "Truck Driver",
  "Farmer",
  "Social Worker"
];


const designations: string[] = [
  // 🧵 Fabric & Textile Related
  "Tailor",
  "Senior Tailor",
  "Master Cutter",
  "Textile Designer",
  "Embroidery Worker",
  "Pattern Maker",
  "Garment Worker",
  "Sewing Machine Operator",
  "Fabric Store Manager",
  "Fabric Store Assistant",
  "Boutique Owner",
  "Boutique Manager",
  "Fashion Designer",
  "Production Supervisor",
  "Quality Checker",
  "Merchandiser",
  "Dyer",
  "Pressing Operator",
  "Clothing Retail Associate",

  // 🌐 Common Across All Fields
  "Owner",
  "Partner",
  "Manager",
  "Assistant Manager",
  "Supervisor",
  "Team Leader",
  "Executive",
  "Senior Executive",
  "Assistant",
  "Clerk",
  "Helper",
  "Operator",
  "Sales Executive",
  "Marketing Executive",
  "Accountant",
  "Cashier",
  "Receptionist",
  "Office Assistant",
  "Storekeeper",
  "Delivery Boy"
];


const gsttypes: string[] = [
  "Regular GST",
  "Composition",
  "Casual Taxable",
  "Non-Resident",
  "ISD",
  "TDS/TCS",
  "E-Commerce Operator"
];

const occupationOptions = occupations.map((occ) => ({
  label: occ,
  value: occ
}));

const designationOptions = designations.map((des) => ({
  label: des,
  value: des
}));



const gstTypeOptions = gsttypes.map((occ) => ({
  label: occ,
  value: occ
}));


const typeOfWorkOptions = [
  { label: 'Full-time', value: 'full_time' },
  { label: 'Part-time', value: 'part_time' },
  { label: 'Freelance', value: 'freelance' },
  { label: 'Contract', value: 'contract' },
  { label: 'Internship', value: 'internship' },
  { label: 'Temporary', value: 'temporary' },
  { label: 'Remote', value: 'remote' },
  { label: 'On-site', value: 'on_site' },
  { label: 'Hybrid', value: 'hybrid' },
  { label: 'Consulting', value: 'consulting' },
  { label: 'Volunteer', value: 'volunteer' },
  { label: 'Project-based', value: 'project_based' },
  { label: 'Apprenticeship', value: 'apprenticeship' },
  { label: 'Seasonal', value: 'seasonal' },
];

type YesNo = 'Yes' | 'No';


interface LedgerModalProps {
  visible: boolean;
  onCancel: () => void;
  onCreate: (data: any) => void;
  initialValues?: (LedgerFormValues & { ledger_id?: number }) | null;
  isEditMode?: boolean;
}



interface Ledger {
  ledger_id: number;
  ledger_account_head?: number;
  ah_name?: string;
}


const LedgerModal: React.FC<LedgerModalProps> = ({
  visible,
  onCancel,
  onCreate,
  initialValues = null,
  isEditMode = false,
}) => {
  const [form] = Form.useForm<LedgerFormValues>();
  const [accountHeads, setAccountHeads] = useState<AccountHead[]>([]);
  // const [companies, setCompany] = useState<CompanyName[]>([]);
  const [product_names, setProductName] = useState<Pn[]>([]);
  const [subHeads, setSubHeads] = useState<SubHead[]>([]);
  // const [categories, setCategories] = useState<Categories[]>([]);
  const [categories, setCategories] = useState<CategoryWithDiscount[]>([]);

  const [discounts, setDiscounts] = useState<Record<string, string>>({});
  const [brandnames, setBrandNames] = useState<BrandNames[]>([]);

  const [imageFile, setImageFile] = useState<File | null>(null);
  const [profileImageFileList, setProfileImageFileList] = useState<UploadFile[]>([]);


  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');

  const [selectedOccupation, setSelectedOccupation] = useState<string>("");
  const [selectedDesignation, setSelectedDesignation] = useState<string>("");

  const [showLinks, setShowLinks] = useState(false);


  const [discountCollapsed, setDiscountCollapsed] = useState(true);

  const [showCompanyDetails, setShowCompanyDetails] = useState(false);

  const [selectedGSTType, setSelectedGSTType] = useState<string>("");

  const [companyCollapsed, setCompanyCollapsed] = useState(false);

  const [otherCollapsed, setOtherCollapsed] = useState(false);

  const [smsCollapsed, setSmsCollapsed] = useState(false);


  const [showCommissionOption, setShowCommissionOption] = useState(false);
  const [showEarlyGoCommissionOption, setShowEarlyGoCommissionOption] = useState(false);

  // pincode blur handler
  const handlePincodeBlur = async (pincode: string, name: number) => {
    if (!/^\d{6}$/.test(pincode)) return;

    try {
      const data = await apiRequest<{
        city: string;
        state: string;
        country: string;
      }>({
        method: "get",
        url: `lookup/pincode/${pincode}`, // change URL to your actual API endpoint
      });

      const currentAddresses = form.getFieldValue("addresses") || [];
      const updatedAddresses = [...currentAddresses];
      updatedAddresses[name] = {
        ...updatedAddresses[name],
        city: data.city,
        state: data.state,
        country: data.country,
      };

      form.setFieldsValue({ addresses: updatedAddresses });
    } catch {
      showError("Could not fetch location data");
    }
  };

  // fetch data for dropdowns
  useEffect(() => {
    apiRequest<AccountHead[]>({ method: "get", url: `account-heads?status=1&ah_parent=0` })
      .then((resp) => setAccountHeads(resp))
      .catch(() => showError("Failed to load account heads"));

    apiRequest<SubHead[]>({ method: "get", url: `account-heads?status=1` })
      .then((resp) => setSubHeads(resp))
      .catch(() => showError("Failed to load sub heads"));

    apiRequest<BrandNames[]>({ method: "get", url: `brand?status=1` })
      .then((resp) => setBrandNames(resp))
      .catch(() => showError("Failed to load company name "));

    apiRequest<Pn[]>({ method: "get", url: `product-names?status=1` })
      .then((resp) => setProductName(resp))
      .catch(() => showError("Failed to load product names"));
  }, []);


  // useEffect(() => {
  //   console.log("Modal visible changed:", initialValues);
  //   console.log("Modal isEditMode changed:", isEditMode);
  //   console.log("Modal visible changed:", visible);
  //   if (visible) {
  //     if (isEditMode && initialValues) {
  //       const values: LedgerFormValues = {
  //         ...initialValues,
  //         ledger_dob: initialValues.ledger_dob
  //           ? dayjs(initialValues.ledger_dob)
  //           : null,
  //         ledger_marriage_anniversary: initialValues.ledger_marriage_anniversary
  //           ? dayjs(initialValues.ledger_marriage_anniversary)
  //           : null,
  //         ledger_work_anniversary: initialValues.ledger_work_anniversary
  //           ? dayjs(initialValues.ledger_work_anniversary)
  //           : null,
  //         links: (initialValues.links || []).map(link => ({
  //           link: link.link_name || "",
  //           description: link.link_url || "",
  //         })),
  //         // banks: initialValues.banks || [],
  //         banks: (initialValues.banks || []).map(bank => ({
  //           ifsc: bank.bank_account_ifsc || "",
  //           holder_name: bank.bank_account_holder_name || "",
  //           bank_name: bank.bank_account_branch_name || "",
  //           address: bank.bank_account_bank_address || "",
  //           acc_no: bank.bank_account_account_no || "",
  //         })),
  //         // phones: initialValues.phones || [],
  //         phones: (initialValues.phones || []).map(phone => ({
  //           first_name: phone.contact_first_name || "",
  //           last_name: phone.contact_last_name || "",
  //           label: phone.contact_label || "",
  //           designation: phone.contact_designation || "",
  //           email: phone.contact_email || "",
  //           type: phone.contact_type as "mobile" | "phone" | undefined,
  //           number: phone.contact_number || "",
  //           std_code: phone.contact_std_code || "",
  //           std_phone: phone.contact_std_phone || "",
  //           sms: phone.contact_sms as "Yes" | "No" | undefined,
  //         })),
  //         categories: (initialValues.categories || []).map(cat => ({
  //           category_id: cat.lcm_category_id || 0,
  //           discount: Number(cat.lcm_discount ?? 0),
  //           special_discount: Number(cat.lcm_special_discount ?? 0),
  //         })),
  //         addresses: (initialValues.addresses || []).map(address => ({
  //           type: address.address_type as "residence" | "office" | undefined,
  //           landmark: address.address_landmark || "",
  //           pincode: address.address_pincode || "",
  //           city: address.address_city || "",
  //           state: address.address_state || "",
  //           country: address.address_country || "",
  //           address: address.address_detail || "",
  //         })),
  //         ledger_deals_in_product: (() => {
  //           const raw = initialValues.ledger_deals_in_product;
  //           if (Array.isArray(raw)) return raw;
  //           if (typeof raw === "string") {
  //             try {
  //               const parsed = JSON.parse(raw);
  //               return Array.isArray(parsed) ? parsed : [];
  //             } catch {
  //               return [];
  //             }
  //           }
  //           return [];
  //         })(),
  //         ledger_deals_in_company: (() => {
  //           const raw = initialValues.ledger_deals_in_company;
  //           if (Array.isArray(raw)) return raw;
  //           if (typeof raw === "string") {
  //             try {
  //               const parsed = JSON.parse(raw);
  //               return Array.isArray(parsed) ? parsed : [];
  //             } catch {
  //               return [];
  //             }
  //           }
  //           return [];
  //         })(),
  //       };
  //       if (initialValues.ledger_image) {
  //         const imageUrl = `${initialValues.ledger_image}`;
  //         setProfileImageFileList([
  //           {
  //             uid: '-1',
  //             name: 'image.png',
  //             status: 'done',
  //             url: imageUrl,
  //           },
  //         ]);
  //         setImageFile(null); // prevent old file being reused
  //       } else {
  //         setProfileImageFileList([]); // <- ✅ clear if no image
  //         setImageFile(null);
  //       }
  //       form.setFieldsValue(values);
  //     } else {
  //       form.resetFields();
  //       setImageFile(null); // ✅ clear uploaded file
  //       setProfileImageFileList([]);
  //     }
  //   }
  // }, [visible, isEditMode, initialValues, form]);


  const formatTimeSafe = (value: any) => {
    if (!value) return "";

    // DayJS object (from TimePicker)
    if (value?.format) {
      return value.format("hh:mm A");
    }

    // ISO strings
    if (typeof value === "string" && value.includes("T")) {
      return dayjs(value).format("hh:mm A");
    }

    // Already AM/PM string -> keep it
    if (/^[0-9]{1,2}:[0-9]{2} (AM|PM)$/i.test(value)) {
      return value;
    }

    return value;
  };



  useEffect(() => {
    const initializeForm = async () => {
      if (!visible) return;

      try {
        console.log("✅ Modal Opened");
        console.log("✅ Edit Mode:", isEditMode);
        console.log("✅ Initial Values:", initialValues);

        // Step 1: Categories fetch करो
        const categoriesData = await apiRequest<Categories[]>({
          method: "get",
          url: "category?status=1",
        });

        console.log("✅ Fetched Categories:", categoriesData);

        if (isEditMode && initialValues) {
          // ==================== EDIT MODE ====================

          // Step 2: Discount data fetch करो
          const discountData = await apiRequest<any[]>({
            method: "get",
            url: `ledger-category-mapping?ledger_id=${initialValues.ledger_id}`,
          });

          console.log("✅ Fetched Discount Data:", discountData);

          // Step 3: Merge categories with discount data
          const mergedCategories = categoriesData.map((cat) => {
            const matchedDiscount = discountData.find(
              (discount) => discount.lcm_category_id === cat.category_id
            );

            return {
              category_id: cat.category_id,
              category_name: cat.category_name,
              category_status: cat.category_status,
              discount: matchedDiscount ? Number(matchedDiscount.lcm_discount) : 0,
              special_discount: matchedDiscount ? Number(matchedDiscount.lcm_special_discount) : 0,
              lcm_id: matchedDiscount?.lcm_id || null,
            };
          });

          console.log("✅ Merged Categories:", mergedCategories);

          // Step 4: Prepare form values for edit mode
          const formValues: LedgerFormValues = {
            ...initialValues,
            ledger_dob: initialValues.ledger_dob ? dayjs(initialValues.ledger_dob) : null,
            ledger_marriage_anniversary: initialValues.ledger_marriage_anniversary
              ? dayjs(initialValues.ledger_marriage_anniversary)
              : null,
            ledger_work_anniversary: initialValues.ledger_work_anniversary
              ? dayjs(initialValues.ledger_work_anniversary)
              : null,

            links: (initialValues.links || []).map(link => ({
              link: link.link_name || "",
              description: link.link_url || "",
            })),

            banks: (initialValues.banks || []).map(bank => ({
              ifsc: bank.bank_account_ifsc || "",
              holder_name: bank.bank_account_holder_name || "",
              bank_name: bank.bank_account_branch_name || "",
              address: bank.bank_account_bank_address || "",
              acc_no: bank.bank_account_account_no || "",
            })),

            phones: (initialValues.phones || []).map(phone => ({
              first_name: phone.contact_first_name || "",
              last_name: phone.contact_last_name || "",
              label: phone.contact_label || "",
              designation: phone.contact_designation || "",
              email: phone.contact_email || "",
              type: phone.contact_type as "mobile" | "phone" | undefined,
              number: phone.contact_number || "",
              std_code: phone.contact_std_code || "",
              std_phone: phone.contact_std_phone || "",
              sms: phone.contact_sms as "Yes" | "No" | undefined,
            })),

            addresses: (initialValues.addresses || []).map(address => ({
              type: address.address_type as "residence" | "office" | undefined,
              landmark: address.address_landmark || "",
              pincode: address.address_pincode || "",
              city: address.address_city || "",
              state: address.address_state || "",
              country: address.address_country || "",
              address: address.address_detail || "",
            })),

            payrolls: (initialValues.payrolls || []).map((p) => ({
              payroll_id: p.payroll_id || undefined,
              payroll_ledger_id: p.payroll_ledger_id || undefined,

              payroll_check_in: p.payroll_check_in
                ? dayjs(p.payroll_check_in, "HH:mm")
                : null,

              payroll_check_out: p.payroll_check_out
                ? dayjs(p.payroll_check_out, "HH:mm")
                : null,

              payroll_working_hours: p.payroll_working_hours || "",

              payroll_lunch_in: p.payroll_lunch_in
                ? dayjs(p.payroll_lunch_in, "HH:mm")
                : null,

              payroll_lunch_out: p.payroll_lunch_out
                ? dayjs(p.payroll_lunch_out, "HH:mm")
                : null,

              payroll_days_of_working: (() => {
                const raw = p.payroll_days_of_working;

                if (Array.isArray(raw)) return raw;          // already array
                if (typeof raw === "string") {
                  return raw
                    .split(",")                               // split by comma
                    .map((d) => d.trim())                     // remove spaces
                    .filter(Boolean);                         // remove empty
                }
                return [];
              })(),

              payroll_days_off: (() => {
                const raw = p.payroll_days_off;

                if (Array.isArray(raw)) return raw;          // already array
                if (typeof raw === "string") {
                  return raw
                    .split(",")                               // split by comma
                    .map((d) => d.trim())                     // remove spaces
                    .filter(Boolean);                         // remove empty
                }
                return [];
              })(),


              payroll_date_of_joining: p.payroll_date_of_joining
                ? dayjs(p.payroll_date_of_joining)
                : null,

              payroll_salary: p.payroll_salary ?? null,

              payroll_type_of_work: p.payroll_type_of_work || "",
              payroll_increment_period: p.payroll_increment_period || "",
              payroll_increment_type: p.payroll_increment_type || "",
              payroll_increment_value: p.payroll_increment_value || undefined,

              payroll_late_allowance_time: p.payroll_late_allowance_time
                ? dayjs(p.payroll_late_allowance_time, "HH:mm")
                : null,

              payroll_late_apply_half_day: (() => {
                const raw = p.payroll_late_apply_half_day as unknown as string;
                return raw === "Yes";
              })(),
              payroll_late_deduct_commission: (() => {
                const raw = p.payroll_late_deduct_commission as unknown as string;
                return raw === "Yes";
              })(),


              payroll_late_commission_percentage: p.payroll_late_commission_percentage ?? null,

              payroll_early_go_allowance_time: p.payroll_early_go_allowance_time
                ? dayjs(p.payroll_early_go_allowance_time, "HH:mm")
                : null,

              payroll_early_apply_half_day: (() => {
                const raw = p.payroll_early_apply_half_day as unknown as string;
                return raw === "Yes";
              })(),

              payroll_early_deduct_commission: (() => {
                const raw = p.payroll_early_deduct_commission as unknown as string;
                return raw === "Yes";
              })(),

              payroll_early_commission_percentage: p.payroll_early_commission_percentage ?? null,
            })),


            ledger_deals_in_product: (() => {
              const raw = initialValues.ledger_deals_in_product;
              if (Array.isArray(raw)) return raw;
              if (typeof raw === "string") {
                try {
                  const parsed = JSON.parse(raw);
                  return Array.isArray(parsed) ? parsed : [];
                } catch {
                  return [];
                }
              }
              return [];
            })(),

            ledger_deals_in_company: (() => {
              const raw = initialValues.ledger_deals_in_company;
              if (Array.isArray(raw)) return raw;
              if (typeof raw === "string") {
                try {
                  const parsed = JSON.parse(raw);
                  return Array.isArray(parsed) ? parsed : [];
                } catch {
                  return [];
                }
              }
              return [];
            })(),
          };

          // Step 5: Handle ledger image
          if (initialValues.ledger_image) {
            const imageUrl = `${initialValues.ledger_image}`;
            setProfileImageFileList([
              {
                uid: '-1',
                name: 'image.png',
                status: 'done',
                url: imageUrl,
              },
            ]);
            setImageFile(null);
          } else {
            setProfileImageFileList([]);
            setImageFile(null);
          }

          // Step 6: Update categories state
          setCategories(mergedCategories);

          // Step 7: Set all form values including categories
          form.setFieldsValue({
            ...formValues,
            payrolls: formValues.payrolls,
            categories: mergedCategories, // ✅ Merged categories with discount
          });

          console.log("✅ Form Values Set Successfully");

        } else {
          // ==================== ADD MODE ====================

          // Blank categories for new ledger
          const blankCategories: CategoryWithDiscount[] = categoriesData.map((cat) => ({
            ...cat,
            discount: 0,
            special_discount: 0,
          }));

          console.log("✅ Blank Categories:", blankCategories);

          // Reset form
          form.resetFields();
          setImageFile(null);
          setProfileImageFileList([]);

          // Set categories
          setCategories(blankCategories);
          form.setFieldsValue({
            categories: blankCategories,
          });

          console.log("✅ Add Mode Initialized");
        }

      } catch (error) {
        showError("Failed to initialize form");
        console.error("❌ Error:", error);
      }
    };

    initializeForm();
  }, [visible, isEditMode, initialValues?.ledger_id, form]);


  const onFinish = async (values: LedgerFormValues) => {
    try {
      console.log("Form submit values:", values);

      const formData = new FormData();
      if (initialValues?.ledger_id) {
        formData.append("ledger_id", initialValues.ledger_id.toString());
      }
      // Ledger fields
      formData.append("ledger_first_name", values.ledger_first_name || "");
      formData.append("ledger_last_name", values.ledger_last_name || "");
      formData.append("ledger_mobile_no", values.ledger_mobile_no || "");
      formData.append("ledger_company_name", values.ledger_company_name || "");
      formData.append("ledger_occupation", values.ledger_occupation || "");
      formData.append("ledger_image", values.ledger_image || "");
      formData.append("ledger_designation", values.ledger_designation || "");
      formData.append(
        "ledger_opening_balance",
        (values.ledger_opening_balance ?? "").toString()
      );
      formData.append("ledger_opening_type", values.ledger_opening_type || "");
      formData.append("ledger_email", values.ledger_email || "");
      formData.append("ledger_gst_type", values.ledger_gst_type || "");
      formData.append("ledger_gstin", values.ledger_gstin || "");
      formData.append("ledger_pan_no", values.ledger_pan_no || "");
      formData.append("ledger_tin_no", values.ledger_tin_no || "");
      formData.append("ledger_cin_no", values.ledger_cin_no || "");
      formData.append("ledger_msme_reg_no", values.ledger_msme_reg_no || "")
      formData.append("ledger_bill_to_bill", values.ledger_bill_to_bill || "")
      formData.append(
        "ledger_interest_rate",
        (values.ledger_interest_rate ?? "").toString()
      );
      formData.append("ledger_interest_style", values.ledger_interest_style || "");
      formData.append(
        "ledger_credit_limit_day",
        (values.ledger_credit_limit_day ?? "").toString()
      );
      formData.append(
        "ledger_reserve_fund",
        (values.ledger_reserve_fund ?? "").toString()
      );
      formData.append(
        "ledger_tds",
        (values.ledger_tds ?? "").toString()
      );
      formData.append(
        "ledger_credit_limit_amount",
        (values.ledger_credit_limit_amount ?? "").toString()
      );
      // formData.append("ledger_interest_rate", values.ledger_interest_rate || "");
      // formData.append("ledger_credit_limit_day", values.ledger_credit_limit_day || "");
      // formData.append("ledger_credit_limit_amount", values.ledger_credit_limit_amount || "");
      formData.append("ledger_offer_festival", values.ledger_offer_festival || "");
      if (imageFile) {
        formData.append('attachments', imageFile); // ✅ binary file
      }

      formData.append(
        "ledger_deals_in_company",
        Array.isArray(values.ledger_deals_in_company)
          ? JSON.stringify(values.ledger_deals_in_company)
          : "[]"
      );

      formData.append(
        "ledger_deals_in_product",
        Array.isArray(values.ledger_deals_in_product)
          ? JSON.stringify(values.ledger_deals_in_product)
          : "[]"
      );

      // Dates
      if (values.ledger_dob) {
        formData.append("ledger_dob", values.ledger_dob.toISOString());
      }
      if (values.ledger_marriage_anniversary) {
        formData.append(
          "ledger_marriage_anniversary",
          values.ledger_marriage_anniversary.toISOString()
        );
      }
      if (values.ledger_work_anniversary) {
        formData.append(
          "ledger_work_anniversary",
          values.ledger_work_anniversary.toISOString()
        );
      }
      console.log("document data", values);
      // Multiple documents
      values.documents?.forEach((doc, index) => {
        formData.append(
          `documents[${index}][doc_type]`,
          doc.document_type
        );
        formData.append(
          `documents[${index}][doc_name]`,
          doc.document_name
        );



        if (doc.attachments && Array.isArray(doc.attachments)) {
          doc.attachments.forEach((file: any, fIndex: number) => {
            if (file?.originFileObj) {
              // send the actual file
              formData.append(
                `documents[${index}][doc_file][${fIndex}]`,
                file.originFileObj as File
              );
            } else if (file instanceof File) {
              // in case it's already a File
              formData.append(
                `documents[${index}][doc_file][${fIndex}]`,
                file
              );
            }
          });
        }
      });

      // phone
      // values.phones?.forEach((ph, index) => {
      //   const contactType = ph.type ?? "";

      //   formData.append(`phones[${index}][first_name]`, ph.first_name ?? "");
      //   formData.append(`phones[${index}][last_name]`, ph.last_name ?? "");
      //   formData.append(`phones[${index}][label]`, ph.label ?? "");
      //   formData.append(`phones[${index}][designation]`, ph.designation ?? "");
      //   formData.append(`phones[${index}][email]`, ph.email ?? "");
      //   formData.append(`phones[${index}][type]`, contactType);
      //   formData.append(`phones[${index}][sms]`, ph.sms ?? ""); // clear sms


      //   if (contactType === "mobile") {
      //     formData.append(`phones[${index}][number]`, ph.number?.toString() ?? "");
      //     formData.append(`phones[${index}][std_code]`, ""); // clear std_code
      //     formData.append(`phones[${index}][phone_no]`, ""); // clear phone_no
      //     formData.append(`phones[${index}][std_phone]`, ""); // clear std_phone
      //     // formData.append(`phones[${index}][sms]`, ""); // clear sms
      //   } else if (contactType === "phone") {
      //     const stdCode = ph.std_code?.toString() ?? "";
      //     formData.append(`phones[${index}][std_code]`, stdCode);
      //     // formData.append(`phones[${index}][phone_no]`, phoneNo);
      //     // formData.append(`phones[${index}][number]`, ""); // mobile field empty
      //     // formData.append(
      //     //   `phones[${index}][std_phone]`,
      //     //   stdCode && phoneNo ? stdCode + phoneNo : ""
      //     // );
      //     formData.append(`phones[${index}][std_phone]`, ph.std_phone ?? "");

      //   }
      // });
      values.phones?.forEach((ph, index) => {
        formData.append(`phones[${index}][first_name]`, ph.first_name ?? "");
        formData.append(`phones[${index}][last_name]`, ph.last_name ?? "");
        formData.append(`phones[${index}][email]`, ph.email ?? "");
        formData.append(`phones[${index}][designation]`, ph.designation ?? "");
        formData.append(`phones[${index}][sms]`, ph.sms ?? "");
        formData.append(`phones[${index}][number]`, ph.number ?? "");
        formData.append(`phones[${index}][std_code]`, ph.std_code ?? "");
        formData.append(`phones[${index}][std_phone]`, ph.std_phone ?? "");
      });


      // links
      values.links?.forEach((l, index) => {
        formData.append(`links[${index}][link]`, l.link ?? "");
        formData.append(`links[${index}][description]`, l.description ?? "");
      });

      // banks
      values.banks?.forEach((b, index) => {
        formData.append(`banks[${index}][ifsc]`, b.ifsc ?? "");
        formData.append(`banks[${index}][bank_name]`, b.bank_name ?? "");
        formData.append(`banks[${index}][address]`, b.address ?? "");
        formData.append(`banks[${index}][acc_no]`, b.acc_no ?? "");
        formData.append(`banks[${index}][holder_name]`, b.holder_name ?? "");
      });

      // address
      values.addresses?.forEach((a, index) => {
        formData.append(`addresses[${index}][type]`, a.type ?? "");
        formData.append(`addresses[${index}][address]`, a.address ?? "");
        formData.append(`addresses[${index}][landmark]`, a.landmark ?? "");
        formData.append(`addresses[${index}][pincode]`, a.pincode ?? "");
        formData.append(`addresses[${index}][city]`, a.city ?? "");
        formData.append(`addresses[${index}][state]`, a.state ?? "");
        formData.append(`addresses[${index}][country]`, a.country ?? "");
      });

      // PAYROLL
      values.payrolls?.forEach((p, index) => {
        formData.append(`payrolls[${index}][payroll_id]`, String(p.payroll_id ?? ""));
        formData.append(`payrolls[${index}][payroll_ledger_id]`, String(p.payroll_ledger_id ?? ""));

        // ⏰ TIME FIELDS — ALWAYS FORMAT
        formData.append(
          `payrolls[${index}][payroll_check_in]`,
          p.payroll_check_in ? dayjs(p.payroll_check_in).format("hh:mm A") : ""
        );

        formData.append(
          `payrolls[${index}][payroll_check_out]`,
          p.payroll_check_out ? dayjs(p.payroll_check_out).format("hh:mm A") : ""
        );

        formData.append(`payrolls[${index}][payroll_working_hours]`, p.payroll_working_hours ?? "");

        formData.append(
          `payrolls[${index}][payroll_lunch_in]`,
          p.payroll_lunch_in ? dayjs(p.payroll_lunch_in).format("hh:mm A") : ""
        );

        formData.append(
          `payrolls[${index}][payroll_lunch_out]`,
          p.payroll_lunch_out ? dayjs(p.payroll_lunch_out).format("hh:mm A") : ""
        );

        formData.append(
          `payrolls[${index}][payroll_days_of_working]`,
          Array.isArray(p.payroll_days_of_working)
            ? p.payroll_days_of_working.join(", ")
            : ""
        );
        formData.append(
          `payrolls[${index}][payroll_days_off]`,
          Array.isArray(p.payroll_days_off)
            ? p.payroll_days_off.join(", ")
            : ""
        );

        // ⏰ Joining date — convert ISO → yyyy-mm-dd
        formData.append(
          `payrolls[${index}][payroll_date_of_joining]`,
          p.payroll_date_of_joining
            ? dayjs(p.payroll_date_of_joining).format("YYYY-MM-DD")
            : ""
        );

        formData.append(`payrolls[${index}][payroll_salary]`, String(p.payroll_salary ?? ""));

        formData.append(`payrolls[${index}][payroll_type_of_work]`, p.payroll_type_of_work ?? "");
        formData.append(`payrolls[${index}][payroll_increment_period]`, p.payroll_increment_period ?? "");
        formData.append(`payrolls[${index}][payroll_increment_type]`, p.payroll_increment_type ?? "");
        formData.append(`payrolls[${index}][payroll_increment_value]`, String(p.payroll_increment_value ?? ""));


        // ⏰ LATE TIME
        formData.append(`payrolls[${index}][payroll_late_allowance_time]`, formatTimeSafe(p.payroll_late_allowance_time));
        formData.append(
          `payrolls[${index}][payroll_late_apply_half_day]`,
          p.payroll_late_apply_half_day ? "Yes" : "No"
        );
        formData.append(
          `payrolls[${index}][payroll_late_deduct_commission]`,
          p.payroll_late_deduct_commission ? "Yes" : "No"
        );

        formData.append(`payrolls[${index}][payroll_late_commission_percentage]`, String(p.payroll_late_commission_percentage ?? ""));

        // ⏰ EARLY TIME
        formData.append(
          `payrolls[${index}][payroll_early_go_allowance_time]`,
          formatTimeSafe(p.payroll_early_go_allowance_time)
        );

        formData.append(
          `payrolls[${index}][payroll_early_apply_half_day]`,
          p.payroll_early_apply_half_day ? "Yes" : "No"
        );
        formData.append(
          `payrolls[${index}][payroll_early_deduct_commission]`,
          p.payroll_early_deduct_commission ? "Yes" : "No"
        );
        formData.append(`payrolls[${index}][payroll_early_commission_percentage]`, String(p.payroll_early_commission_percentage ?? ""));
      });


      // values.categories?.forEach((cat, index) => {
      //   formData.append(`categories[${index}][category_id]`, String(cat.category_id ?? ""));
      //   formData.append(`categories[${index}][discount]`, String(cat.discount ?? ""));
      //   formData.append(`categories[${index}][special_discount]`, String(cat.special_discount ?? ""));
      // });

      values.categories?.forEach((cat, index) => {
        formData.append(`categories[${index}][category_id]`, String(cat.category_id ?? ""));
        formData.append(`categories[${index}][discount]`, String(cat.discount ?? 0));
        formData.append(`categories[${index}][special_discount]`, String(cat.special_discount ?? 0));
      });



      const method = isEditMode ? "put" : "post";
      const url = isEditMode ? "edit-ledger" : "add-ledger";

      const resp = await apiRequest<any>({
        method,
        url,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      showSuccess(isEditMode ? "Ledger updated!" : "Ledger created!");
      form.resetFields();
      if (!visible) { //check this
        setImageFile(null);
        setProfileImageFileList([]);
      }
      onCreate(resp);
      onCancel();
    } catch (err) {
      console.error(err);
      showError(isEditMode ? "Update failed" : "Create failed");
    }
  };

  // const fetchcategory = async () => {
  //   try {
  //     const data = await apiRequest<Categories[]>({
  //       method: "get",
  //       url: `category?status=1`,
  //     });
  //     //   setCategories(data);
  //     if (data && data.length) {
  //       form.setFieldsValue({
  //         categories: data.map((cat) => ({
  //           category_id: cat.category_id,
  //           category_name: cat.category_name,
  //           discount: "",
  //           special_discount: "",
  //         })),
  //       });
  //       setCategories(data); // state को भी अपडेट करें
  //     }
  //   } catch (error) {
  //     showError("Failed to fetch category");
  //     console.error(error);
  //   }
  // };


  // const fetchcategory = async () => {
  //   try {
  //     const data = await apiRequest<Categories[]>({
  //       method: "get",
  //       url: `category?status=1`,
  //     });

  //     const mapped = data.map((cat: Categories) => ({
  //       ...cat,
  //       discount: 0,
  //       special_discount: 0,
  //     }));
  //     setCategories(mapped);
  //   } catch (error) {
  //     showError("Failed to fetch category");
  //     console.error(error);
  //   }
  // };

  // useEffect(() => {
  //   fetchcategory();
  // }, []);


  // useEffect(() => {
  //   fetchcategory();
  // }, []);

  // const fetchcategory = async () => {
  //   try {
  //     const data = await apiRequest<Categories[]>({
  //       method: "get",
  //       url: `category?status=1`,
  //     });

  //     const mapped: CategoryWithDiscount[] = data.map((cat) => ({
  //       ...cat,
  //       discount: 0,
  //       special_discount: 0,
  //     }));

  //     setCategories(mapped);
  //   } catch (error) {
  //     showError("Failed to fetch category");
  //     console.error(error);
  //   }
  // };


  // Categories और discount data ko merge karne ka function
  // ✅ Step 1: mergeDiscountWithCategories function को correct करो




  const handleDiscountChange = (categoryId: number, value: string) => {
    setDiscounts((prev) => ({
      ...prev,
      [categoryId]: value,
    }));
  };

  // image preview 
  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as File);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
  };

  // Utility function to convert image to base64
  const getBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });

  const uploadButton = (
    <div
      style={{
        width: 220,
        height: 220,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <PlusOutlined style={{ fontSize: 24 }} />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );


  const handleOccupationChange = (value: string) => {
    setSelectedOccupation(value);
  };

  const handleDesignationChange = (value: string) => {
    setSelectedDesignation(value);
  };

  const handleGSTTypeChange = (value: string) => {
    setSelectedGSTType(value);
  };

  // Handler for dropdown change
  const onBillToBillChange = (value: string) => {
    setShowLinks(value === "Yes");
    if (value !== "Yes") {
      // Optionally reset links when switching to "No"
      form.setFieldsValue({ links: [] });
    }
  };

  // Outside of return, in the same file
  const autoInsertSlash = (input: HTMLInputElement) => {
    let value = input.value.replace(/\D/g, ""); // Keep only digits

    // Insert slashes automatically after 2nd and 4th digits
    if (value.length > 2) value = value.slice(0, 2) + "/" + value.slice(2);
    if (value.length > 5) value = value.slice(0, 5) + "/" + value.slice(5);

    input.value = value;
  };

  const handleDOBKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    const input = e.currentTarget as HTMLInputElement; // Cast to input
    const value = input.value;

    const allowedSpecialKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Tab",
      "Escape",
      "Enter",
    ];

    // Allow Ctrl/⌘ + A/C/V/X
    if ((e.ctrlKey || e.metaKey) && ["a", "c", "v", "x"].includes(e.key.toLowerCase())) return;

    // Allow special keys
    if (allowedSpecialKeys.includes(e.key)) return;

    // Count digits in input
    const digitCount = (value.match(/\d/g) || []).length;

    // Allow digits only if less than 8 digits
    if (/^[0-9]$/.test(e.key)) {
      if (digitCount >= 8) {
        e.preventDefault();
        return;
      }
    } else if (e.key === "/" || e.key === "-") {
      // Allow slash or hyphen but max 2
      const count = (value.match(new RegExp(`\\${e.key}`, "g")) || []).length;
      if (count >= 2) {
        e.preventDefault();
        return;
      }
    } else {
      // Block everything else
      e.preventDefault();
      return;
    }

    // Auto-insert slash after 2nd and 4th digits
    setTimeout(() => autoInsertSlash(input), 0); // Timeout to let key input happen
  };

  // for persentage reserve fund, tsd
  // utils/inputValidators.ts
  const decimalInputKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    maxIntegerDigits = 3,
    maxDecimalDigits = 2,
    maxValue = 100
  ) => {
    const value = e.currentTarget.value;
    const key = e.key;
    const cursorPos = e.currentTarget.selectionStart || 0;

    // Allow copy, cut, paste, select-all
    if ((e.ctrlKey || e.metaKey) && ["c", "x", "v", "a"].includes(key.toLowerCase())) return;

    // Block invalid keys
    if (["-", "+", "e", "E", " "].includes(key)) {
      e.preventDefault();
      return;
    }

    // Allow navigation
    if (["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(key)) return;

    // Only digits & dot
    if (!/^[0-9.]$/.test(key)) {
      e.preventDefault();
      return;
    }

    // Dot cannot be first
    if (key === "." && value === "") {
      e.preventDefault();
      return;
    }

    // Only one dot
    if (key === "." && value.includes(".")) {
      e.preventDefault();
      return;
    }

    const parts = value.split(".");

    // Before dot: max integer digits
    if (!value.includes(".") && parts[0].length >= maxIntegerDigits && key !== ".") {
      e.preventDefault();
      return;
    }

    // After dot: max decimal digits considering cursor position
    if (value.includes(".") && cursorPos > value.indexOf(".")) {
      const decLength = value.length - value.indexOf(".") - 1;
      if (decLength >= maxDecimalDigits) {
        e.preventDefault();
        return;
      }
    }

    // Max value check
    const newValue = value + key;
    const num = parseFloat(newValue);
    if (!isNaN(num) && num > maxValue) {
      e.preventDefault();
    }
  };


  const decimalInputPaste = (
    e: React.ClipboardEvent<HTMLInputElement>,
    maxIntegerDigits = 3,
    maxDecimalDigits = 2,
    maxValue = 100
  ) => {
    const pasteValue = e.clipboardData.getData("text");

    // Allow only numbers + dot
    if (!/^[0-9.]+$/.test(pasteValue)) {
      e.preventDefault();
      return;
    }

    // Must match pattern: max integer & decimal digits
    const regex = new RegExp(`^\\d{1,${maxIntegerDigits}}(\\.\\d{0,${maxDecimalDigits}})?$`);
    if (!regex.test(pasteValue)) {
      e.preventDefault();
      return;
    }

    // Must not exceed maxValue
    if (parseFloat(pasteValue) > maxValue) {
      e.preventDefault();
      return;
    }
  };


  const handleTimeChange = (changedValues: any, allValues: any) => {
    if (!changedValues.payrolls) return;

    changedValues.payrolls.forEach((changedItem: any, index: number) => {
      const payroll = allValues.payrolls[index];
      if (!payroll) return;

      const { payroll_check_in, payroll_check_out } = payroll;

      if (payroll_check_in && payroll_check_out) {
        const start = dayjs(payroll_check_in);
        const end = dayjs(payroll_check_out);

        let diff = end.diff(start, "minute");
        if (diff < 0) diff += 24 * 60; // overnight shifts

        const hours = Math.floor(diff / 60);
        const minutes = diff % 60;

        const result = minutes > 0 ? `${hours}h ${minutes}m` : `${hours} hours`;

        form.setFields([
          {
            name: ["payrolls", index, "payroll_working_hours"],
            value: result,
          },
        ]);
      }
    });
  };




  return (
    <>
      <Modal
        visible={visible}
        title={isEditMode ? "Edit Ledger" : "Add Ledger"}
        onCancel={onCancel}
        footer={null}
        width="95%"
        destroyOnClose
        maskClosable={false}
        centered
      >

        <Form form={form} layout="vertical" onFinish={onFinish}
          onValuesChange={handleTimeChange}>
          <>
            <span><h4 style={{ margin: "0 0 10px 0", padding: 0 }}>Ledger</h4></span>
            <Row gutter={16}>
              <Col span={16}>
                <Row gutter={16}>
                  {/* First Name */}
                  <Col span={12}>
                    <Form.Item name="ledger_first_name" label="First Name">
                      <Form.Item noStyle dependencies={["ledger_first_name"]}>
                        {({ getFieldValue, setFieldsValue }) => {
                          const currentValue = getFieldValue("ledger_first_name") || "";

                          const handleChange = (
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            let value = e.target.value;

                            // केवल alphabets allow
                            value = value.replace(/[^a-zA-Z]/g, "");

                            // limit 50 chars
                            value = value.slice(0, 50);

                            // पहला अक्षर capital
                            if (value.length > 0) {
                              value = value.charAt(0).toUpperCase() + value.slice(1);
                            }

                            // ✅ Sync with first phone contact's first_name
                            const phones = getFieldValue("phones") || [];
                            if (phones.length > 0) {
                              phones[0] = {
                                ...phones[0],
                                first_name: value,
                              };
                              setFieldsValue({
                                ledger_first_name: value,
                                phones: phones
                              });
                            } else {
                              setFieldsValue({ ledger_first_name: value });
                            }
                          };

                          return (
                            <Input
                              value={currentValue}
                              maxLength={50}
                              onChange={handleChange}
                              placeholder="Enter first name"
                              suffix={
                                <span style={{ fontSize: "12px", color: "#888" }}>
                                  {currentValue.length}/50
                                </span>
                              }
                            />
                          );
                        }}
                      </Form.Item>
                    </Form.Item>
                  </Col>


                  {/* Last Name */}
                  <Col span={12}>
                    <Form.Item name="ledger_last_name" label="Last Name">
                      <Form.Item noStyle dependencies={["ledger_last_name"]}>
                        {({ getFieldValue, setFieldsValue }) => {
                          const currentValue = getFieldValue("ledger_last_name") || "";

                          const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                            let value = e.target.value;

                            // केवल alphabets और space allow
                            value = value.replace(/[^a-zA-Z\s]/g, "");

                            // limit 50 chars
                            value = value.slice(0, 50);

                            // पहला अक्षर capital
                            if (value.length > 0) {
                              value = value.charAt(0).toUpperCase() + value.slice(1);
                            }

                            // ✅ Sync with first phone contact's last_name
                            const phones = getFieldValue("phones") || [];
                            if (phones.length > 0) {
                              phones[0] = {
                                ...phones[0],
                                last_name: value,
                              };
                              setFieldsValue({
                                ledger_last_name: value,
                                phones: phones
                              });
                            } else {
                              setFieldsValue({ ledger_last_name: value });
                            }
                          };

                          return (
                            <Input
                              value={currentValue}
                              maxLength={50}
                              onChange={handleChange}
                              placeholder="Enter last name"
                              suffix={
                                <span style={{ fontSize: "12px", color: "#888" }}>
                                  {currentValue.length}/50
                                </span>
                              }
                            />
                          );
                        }}
                      </Form.Item>
                    </Form.Item>
                  </Col>


                  {/* Account Head */}
                  <Col span={12}>
                    <Form.Item name="ledger_account_head" label="Account Head">
                      <Select placeholder="Select head" allowClear>
                        {accountHeads.map((h) => (
                          <Option key={h.ah_id} value={h.ah_id}>
                            {h.ah_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                  </Col>

                  {/* Account Sub Head */}
                  <Col span={12}>
                    <Form.Item name="ledger_sub_account_head" label="Sub Head">
                      <Select placeholder="Select sub-head" allowClear>
                        {subHeads.map((sh) => (
                          <Option key={sh.ah_id} value={sh.ah_id}>
                            {sh.ah_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                </Row>
              </Col>
              <Col span={8}>
                {/* ledger image */}
                <Row justify="center">
                  <Col>
                    <Form.Item label="Upload Ledger Image" required >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: 'center',
                        }}
                      >
                        <Upload
                          beforeUpload={() => false}
                          listType="picture-card"
                          maxCount={1}
                          fileList={profileImageFileList}
                          onPreview={handlePreview} // 👈 Add this
                          onChange={({ fileList }) => {
                            setProfileImageFileList(fileList);
                            const rawFile = fileList[0]?.originFileObj;
                            if (rawFile instanceof File) {
                              setImageFile(rawFile); // ✅ set real File here
                            } else {
                              setImageFile(null);
                            }
                          }}
                        >
                          {profileImageFileList.length >= 1 ? null : uploadButton}
                        </Upload>
                      </div>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>


              {/* Mobile Number */}
              <Col span={8}>
                <Form.Item
                  name="ledger_mobile_no"
                  label="Mobile No"
                  rules={[
                    { required: true, message: "Required" },
                    {
                      pattern: /^[0-9]{10}$/,
                      message: "Mobile number must be 10 digits",
                    },
                  ]}
                >
                  <Form.Item noStyle dependencies={["ledger_mobile_no"]}>
                    {({ getFieldValue, setFieldsValue }) => {
                      const currentValue = getFieldValue("ledger_mobile_no") || "";

                      const handleChange = (
                        e: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        let value = e.target.value;

                        // Allow only digits
                        value = value.replace(/[^0-9]/g, "");

                        // Limit to 10 digits
                        value = value.slice(0, 10);

                        setFieldsValue({ ledger_mobile_no: value });
                      };

                      const handleBlur = () => {
                        const value = getFieldValue("ledger_mobile_no") || "";
                        if (!value) {
                          setFieldsValue({ ledger_mobile_no: "0123456789" });
                        }
                      };

                      return (
                        <Input
                          value={currentValue}
                          maxLength={10}
                          type="tel"
                          placeholder="Enter mobile number"
                          onChange={handleChange}
                          onBlur={handleBlur} // <-- Auto-fill here
                          suffix={
                            <span style={{ fontSize: "12px", color: "#888" }}>
                              {currentValue.length}/10
                            </span>
                          }
                        />
                      );
                    }}
                  </Form.Item>
                </Form.Item>
              </Col>

              {/*  Date of Birth */}
              <Col span={8}>
                <Form.Item
                  name="ledger_dob"
                  label="Date of Birth"
                  rules={[
                    { required: true, message: "Date of Birth is required" },
                    {
                      validator: (_, value) => {
                        if (!value) return Promise.resolve();

                        const today = dayjs();
                        const minDate = dayjs().subtract(120, "years");

                        if (value.isAfter(today)) {
                          return Promise.reject("DOB cannot be in the future");
                        }
                        if (value.isBefore(minDate)) {
                          return Promise.reject("DOB cannot be more than 120 years old");
                        }
                        return Promise.resolve();
                      }
                    }
                  ]}
                >
                  <Form.Item noStyle dependencies={["ledger_dob"]}>
                    {({ getFieldValue, setFieldsValue }) => {
                      const currentValue = getFieldValue("ledger_dob") || null;

                      const handleDOBChange = (date: any) => {
                        setFieldsValue({ ledger_dob: date });  // ✅ ONLY update DOB — no sync with phones
                      };

                      return (
                        // <DatePicker
                        //   value={currentValue}
                        //   onChange={handleDOBChange}
                        //   style={{ width: "100%", borderRadius: "4px" }}
                        //   format={["DD/MM/YYYY"]}
                        //   disabledDate={(current) =>
                        //     current && (current > dayjs() || current < dayjs().subtract(120, "years"))
                        //   }
                        //   onKeyDown={(e: React.KeyboardEvent<HTMLElement>) => {
                        //      const input = e.currentTarget as HTMLInputElement; // <-- cast to input
                        //     const value = input.value;
                        //     const allowedSpecialKeys = [
                        //       "Backspace",
                        //       "Delete",
                        //       "ArrowLeft",
                        //       "ArrowRight",
                        //       "ArrowUp",
                        //       "ArrowDown",
                        //       "Tab",
                        //       "Escape",
                        //       "Enter",
                        //     ];

                        //     // Allow Ctrl/⌘ + A/C/V/X
                        //     if (
                        //       (e.ctrlKey || e.metaKey) &&
                        //       ["a", "c", "v", "x"].includes(e.key.toLowerCase())
                        //     ) {
                        //       return;
                        //     }

                        //     // Allow special keys
                        //     if (allowedSpecialKeys.includes(e.key)) {
                        //       return;
                        //     }

                        //     // Count digits in input
                        //     const digitCount = (value.match(/\d/g) || []).length;

                        //     // Allow digits only if less than 8 digits
                        //     if (/^[0-9]$/.test(e.key)) {
                        //       if (digitCount < 8) return;
                        //       e.preventDefault();
                        //       return;
                        //     }

                        //      // ✔ Allow slash, but max 2
                        //     if (e.key === "/") {
                        //       if ((value.match(/\//g) || []).length < 2) return;
                        //       e.preventDefault();
                        //       return;
                        //     }

                        //     // ✔ Allow hyphen, but max 2
                        //     if (e.key === "-") {
                        //       if ((value.match(/-/g) || []).length < 2) return;
                        //       e.preventDefault();
                        //       return;
                        //     }

                        //     // ❌ Block everything else
                        //     e.preventDefault();
                        //   }}
                        // />
                        <DatePicker
                          value={currentValue}
                          onChange={handleDOBChange}
                          style={{ width: "100%", borderRadius: "4px" }}
                          format={["DD/MM/YYYY"]}
                          disabledDate={(current) =>
                            current && (current > dayjs() || current < dayjs().subtract(120, "years"))
                          }
                          onKeyDown={handleDOBKeyDown} // ✅ Reusing the function
                        />

                      );
                    }}
                  </Form.Item>
                </Form.Item>
              </Col>


              {/* Marriage Anniversary */}
              <Col span={8}>
                <Form.Item
                  name="ledger_marriage_anniversary"
                  label="Marriage Anniversary"
                  rules={[
                    {
                      validator: (_, value) => {
                        if (!value) return Promise.resolve();

                        const today = dayjs();
                        const minDate = dayjs().subtract(120, "years");

                        if (value.isBefore(minDate)) {
                          return Promise.reject("Anniversary cannot be more than 120 years old");
                        }

                        return Promise.resolve();
                      }
                    }
                  ]}
                >
                  <Form.Item noStyle dependencies={["ledger_marriage_anniversary"]}>
                    {({ getFieldValue, setFieldsValue }) => {
                      const currentValue = getFieldValue("ledger_marriage_anniversary") || null;

                      const handleAnnivChange = (date: dayjs.Dayjs | null) => {
                        setFieldsValue({ ledger_marriage_anniversary: date });
                      };

                      return (
                        <DatePicker
                          value={currentValue}
                          onChange={handleAnnivChange}
                          style={{ width: "100%", borderRadius: "4px" }}
                          format={["DD/MM/YYYY"]}
                          disabledDate={(current) =>
                            current && (current > dayjs() || current < dayjs().subtract(120, "years"))
                          }
                          onKeyDown={handleDOBKeyDown} // ✅ Reusing the function
                        />
                      );
                    }}
                  </Form.Item>
                </Form.Item>
              </Col>


              {/* Offer Festival */}
              <Col span={8}>
                <Form.Item
                  name="ledger_offer_festival"
                  label="Festival Offer"
                >
                  <Select placeholder="Select Festival">
                    <Select.Option value="diwali">Diwali</Select.Option>
                    <Select.Option value="holi">Holi</Select.Option>
                    <Select.Option value="eid">Eid</Select.Option>
                    <Select.Option value="christmas">Christmas</Select.Option>
                    <Select.Option value="pongal">Pongal</Select.Option>
                  </Select>
                </Form.Item>
              </Col>

              {/* Occupation */}
              <Col span={8}>
                <Form.Item name="ledger_occupation" label="Occupation">
                  {/* <Input /> */}
                  <Select
                    showSearch
                    placeholder="Select your occupation"
                    value={selectedOccupation}
                    onChange={handleOccupationChange}
                    options={occupationOptions}
                    filterOption={(input, option) =>
                      (option?.label as string).toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>


              {/* designation */}
              <Col span={8}>
                <Form.Item name="ledger_designation" label="Designation">
                  <Form.Item noStyle dependencies={["ledger_designation"]}>
                    {({ getFieldValue, setFieldsValue }) => {
                      const currentValue = getFieldValue("ledger_designation");

                      const handleDesignationChange = (value: string) => {
                        setSelectedDesignation(value);

                        // Sync with first phone contact's designation
                        const phones = getFieldValue("phones") || [];
                        if (phones.length > 0) {
                          phones[0] = {
                            ...phones[0],
                            designation: value,
                          };
                          setFieldsValue({
                            ledger_designation: value,
                            phones: phones
                          });
                        } else {
                          setFieldsValue({ ledger_designation: value });
                        }
                      };

                      return (
                        <Select
                          showSearch
                          placeholder="Select your designation"
                          value={currentValue !== undefined ? currentValue : undefined} // ✅ Only use value if defined
                          onChange={handleDesignationChange}
                          options={designationOptions}
                          filterOption={(input, option) =>
                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                          }
                          style={{ width: '100%' }}
                          allowClear // optional: lets user clear the value to show placeholder again
                        />
                      );
                    }}
                  </Form.Item>
                </Form.Item>
              </Col>


              {/* <Divider style={{ marginTop: 4, marginBottom: 16 }} /> */}

              <Form.Item shouldUpdate noStyle>
                {(form) => (
                  <div style={{
                    background: "#f5f5f5",
                    width: "98%",
                    margin: "0 auto 20px auto",
                    padding: "24px 8px",
                    borderRadius: "6px",
                    // margin: '0 0 20px 0',
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}>
                    <Row
                      gutter={16}
                      style={{
                        margin: 0,
                        alignItems: "center",
                      }}
                    >
                      <Col span={12}>
                        <span><h4 style={{ margin: "10px 0 10px 0", padding: 0 }}>Company Info </h4></span>
                      </Col>

                      <Col span={12} style={{ textAlign: "right" }}>
                        <Button
                          type="text"
                          size="small"
                          icon={companyCollapsed ? <CaretUpOutlined /> : <CaretDownOutlined />}
                          onClick={() => setCompanyCollapsed(!companyCollapsed)}
                        >
                          {companyCollapsed ? "Hide" : "Add"}
                        </Button>
                      </Col>
                    </Row>
                    {/* Company Details block */}
                    {companyCollapsed && (
                      <div
                        style={{
                          background: "#f5f5f5",
                          borderRadius: "6px",
                          marginTop: 16,
                          position: "relative",
                        }}
                      >
                        <Row gutter={16}>
                          {/* Company Name */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_company_name"
                              label="Company Name"
                              rules={[
                                { required: true, message: "Company Name is required" },
                                {
                                  pattern: /^[A-Za-z0-9&.,'()\- ]+$/,
                                  message: "Company Name contains invalid characters",
                                },
                                {
                                  pattern: /^(?!\d+$).+$/,
                                  message: "Company Name cannot be only numbers",
                                },
                              ]}
                            >
                              <Form.Item noStyle dependencies={["ledger_company_name"]}>
                                {({ getFieldValue, setFieldsValue }) => {
                                  const currentValue = getFieldValue("ledger_company_name") || "";

                                  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                                    let value = e.target.value;

                                    // ❌ DO NOT remove numbers
                                    // ❌ DO NOT remove special company characters
                                    // Only remove completely invalid characters (emoji etc.)
                                    value = value.replace(/[^A-Za-z0-9&.,'()\- ]/g, "");

                                    // Max 100 chars
                                    value = value.slice(0, 100);

                                    // First letter uppercase
                                    if (value.length > 0) {
                                      value = value.charAt(0).toUpperCase() + value.slice(1);
                                    }

                                    setFieldsValue({ ledger_company_name: value });
                                  };

                                  return (
                                    <Input
                                      value={currentValue}
                                      maxLength={100}
                                      onChange={handleChange}
                                      placeholder="Enter company name"
                                      suffix={
                                        <span style={{ fontSize: "12px", color: "#888" }}>
                                          {currentValue.length}/100
                                        </span>
                                      }
                                    />
                                  );
                                }}
                              </Form.Item>
                            </Form.Item>
                          </Col>

                          {/* GST Type */}
                          <Col span={8}>
                            <Form.Item name="ledger_gst_type" label="GST Type">
                              <Select
                                showSearch
                                placeholder="Select GST Type"
                                options={gstTypeOptions}
                                filterOption={(input, option) =>
                                  (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                }
                              />
                            </Form.Item>
                          </Col>

                          {/* GST */}
                          {/* <Col span={8}>
                            <Form.Item
                              name="ledger_gstin"
                              label="GSTIN/UIN"
                              rules={[
                                {
                                  pattern: /^[0-9A-Z]{15}$/,
                                  message: "Enter valid 15-character GSTIN",
                                },
                              ]}
                              getValueFromEvent={(e) => {
                                let value = e.target.value;

                                // Sirf numbers aur alphabets allow karo
                                value = value.replace(/[^0-9a-zA-Z]/g, "");

                                // Auto-uppercase me convert karo
                                value = value.toUpperCase();

                                // Max 15 characters limit
                                if (value.length > 15) {
                                  value = value.slice(0, 15);
                                }

                                return value;
                              }}
                            >
                              <Input
                                placeholder="Enter GSTIN"
                                maxLength={15}
                                onChange={(e) => {
                                  // yahan live counter update hoga
                                  const counterEl = document.getElementById("gstin-counter");
                                  if (counterEl) {
                                    counterEl.innerText = `${e.target.value.length}/15`;
                                  }
                                }}
                                suffix={
                                  <span
                                    id="gstin-counter"
                                    style={{ fontSize: "12px", color: "#888" }}
                                  >
                                    0/15
                                  </span>
                                }
                                onBlur={async (e) => {
                                  const gstin = e.target.value.trim();
                                  if (!gstin) return;

                                  try {
                                    const response = await apiRequest({
                                      url: "check-gstin",
                                      method: "get",
                                      params: { gstIn: gstin },
                                    });

                                    if (response?.data) {
                                      // valid GSTIN case
                                    } else {
                                      showSuccess(response?.message || "Found GSTIN");
                                    }
                                  } catch (err) {
                                    showError("Failed to validate GSTIN");
                                    console.error(err);
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col> */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_gstin"
                              label="GSTIN/UIN"
                              rules={[
                                {
                                  pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                                  message: "Enter valid 15-character GSTIN",
                                },
                              ]}
                              getValueFromEvent={(e) => {
                                let value = e.target.value;
                                value = value.replace(/[^0-9a-zA-Z]/g, "").toUpperCase();
                                if (value.length > 15) value = value.slice(0, 15);
                                return value;
                              }}
                            >
                              <Input
                                placeholder="Enter GSTIN"
                                maxLength={15}
                                onChange={(e) => {
                                  const counterEl = document.getElementById("gstin-counter");
                                  if (counterEl) counterEl.innerText = `${e.target.value.length}/15`;
                                }}
                                suffix={
                                  <span id="gstin-counter" style={{ fontSize: "12px", color: "#888" }}>
                                    0/15
                                  </span>
                                }
                                onBlur={async (e) => {
                                  const gstin = e.target.value.trim();
                                  if (!gstin) return;

                                  // ✅ Extract PAN from GSTIN (characters 3-12)
                                  if (gstin.length === 15) {
                                    const panFromGstin = gstin.slice(2, 12);
                                    form.setFieldsValue({ ledger_pan_no: panFromGstin });
                                  }

                                  // ✅ GSTIN API validation
                                  try {
                                    const response = await apiRequest({
                                      url: "check-gstin",
                                      method: "get",
                                      params: { gstIn: gstin },
                                    });

                                    if (response?.data) {
                                      // GSTIN is valid, optionally show success
                                    } else {
                                      showSuccess(response?.message || "Found GSTIN");
                                    }
                                  } catch (err) {
                                    showError("Failed to validate GSTIN");
                                    console.error(err);
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>

                          {/* Pan no.  */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_pan_no"
                              label="PAN No"
                              rules={[
                                {
                                  pattern: /^[A-Z0-9]{10}$/,
                                  message: "Enter valid 10-character PAN No",
                                },
                              ]}
                              getValueFromEvent={(e) => {
                                let value = e.target.value;

                                // Sirf numbers aur alphabets allow karo
                                value = value.replace(/[^0-9a-zA-Z]/g, "");

                                // Auto-uppercase me convert karo
                                value = value.toUpperCase();

                                // Max 10 characters limit
                                if (value.length > 10) {
                                  value = value.slice(0, 10);
                                }

                                return value;
                              }}
                            >
                              <Input
                                placeholder="Enter PAN No"
                                maxLength={10}
                                onChange={(e) => {
                                  // Live counter update
                                  const counterEl = document.getElementById("pan-counter");
                                  if (counterEl) {
                                    counterEl.innerText = `${e.target.value.length}/10`;
                                  }
                                }}
                                suffix={
                                  <span
                                    id="pan-counter"
                                    style={{ fontSize: "12px", color: "#888" }}
                                  >
                                    0/10
                                  </span>
                                }
                              />
                            </Form.Item>
                          </Col>

                          {/* Tin No */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_tin_no"
                              label="TIN No"
                              rules={[
                                {
                                  pattern: /^[0-9]{11}$/,
                                  message: "TIN must be exactly 11 digits",
                                },
                              ]}
                            >
                              <Input
                                maxLength={11}
                                placeholder="Enter TIN No"
                                onChange={(e) => {
                                  const digitsOnly = e.target.value.replace(/\D/g, "");
                                  form.setFieldsValue({ ledger_tin_no: digitsOnly });

                                  const counterEl = document.getElementById("tin-counter");
                                  if (counterEl) {
                                    counterEl.innerText = `${digitsOnly.length}/11`;
                                    counterEl.style.color = digitsOnly.length === 11 ? "red" : "#888";
                                  }
                                }}
                                suffix={
                                  <span id="tin-counter" style={{ fontSize: "12px", color: "#888" }}>
                                    0/11
                                  </span>
                                }
                              />
                            </Form.Item>
                          </Col>

                          {/* Cin No */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_cin_no"
                              label="CIN No"
                              rules={[
                                {
                                  pattern: /^[LU][0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/,
                                  message: "Valid CIN format required (e.g., U12345MH2006PTC123456)",
                                },
                              ]}
                            >
                              <Input
                                maxLength={21}
                                placeholder="e.g., U12345MH2006PTC123456"
                                onChange={(e) => {
                                  const upperCaseValue = e.target.value.toUpperCase();
                                  form.setFieldsValue({ ledger_cin_no: upperCaseValue });

                                  const counterEl = document.getElementById("cin-counter");
                                  if (counterEl) {
                                    counterEl.innerText = `${upperCaseValue.length}/21`;
                                    counterEl.style.color =
                                      upperCaseValue.length === 21 ? "red" : "#888";
                                  }
                                }}
                                suffix={
                                  <span
                                    id="cin-counter"
                                    style={{ fontSize: "12px", color: "#888" }}
                                  >
                                    0/21
                                  </span>
                                }
                              />
                            </Form.Item>
                          </Col>


                          {/* MSME Teg no */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_msme_reg_no"
                              label="MSME Registration Number"
                              rules={[
                                { required: true, message: "Please enter your MSME Registration Number" },
                                {
                                  pattern: MSME_REGEX,
                                  message: "Enter a valid MSME Reg No (e.g. UDYAM-GJ-12-1234567)",
                                },
                              ]}
                            >
                              <Input
                                maxLength={25}
                                placeholder="e.g. UDYAM-GJ-12-1234567"
                                onChange={(e) => {
                                  const value = e.target.value.toUpperCase(); // Force uppercase
                                  form.setFieldsValue({ ledger_msme_reg_no: value });

                                  const counterEl = document.getElementById("msme-counter");
                                  if (counterEl) {
                                    counterEl.innerText = `${value.length}/25`;
                                    counterEl.style.color = value.length === 25 ? "red" : "#888";
                                  }
                                }}
                                suffix={
                                  <span
                                    id="msme-counter"
                                    style={{ fontSize: "12px", color: "#888" }}
                                  >
                                    0/25
                                  </span>
                                }
                              />
                            </Form.Item>
                          </Col>

                          {/* Deals in COmpnay */}
                          <Col span={8}>
                            <Form.Item name="ledger_deals_in_company" label="Deals In Company">
                              <Select
                                className="input-bordor-radius-with-border "
                                style={{ width: "100%" }}
                                placeholder="Select comapny name"
                                allowClear
                                mode="multiple"
                                showSearch
                              >
                                {brandnames.map((bn) => (
                                  <Option key={bn.brand_id} value={bn.brand_id}>
                                    {bn.brand_name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>

                          {/* Deals in products */}
                          <Col span={8}>
                            <Form.Item name="ledger_deals_in_product" label="Deals In Product">
                              <Select
                                className="input-bordor-radius-with-border"
                                style={{ width: "100%" }}
                                placeholder="Select comapny name"
                                allowClear
                                mode="multiple"
                                showSearch
                              >
                                {product_names.map((pn) => (
                                  <Option key={pn.pn_id} value={pn.pn_id}>
                                    {pn.pn_name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>

                          {/* Work Anniversary */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_work_anniversary"
                              label="Work Anniversary"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (!value) return Promise.resolve();

                                    const today = dayjs();
                                    const minDate = dayjs().subtract(120, "years");

                                    if (value.isBefore(minDate)) {
                                      return Promise.reject("Work Anniversary cannot be more than 120 years old");
                                    }
                                    if (value.isAfter(today)) {
                                      return Promise.reject("Work Anniversary cannot be in the future");
                                    }

                                    return Promise.resolve();
                                  }
                                }
                              ]}
                            >
                              <Form.Item noStyle dependencies={["ledger_work_anniversary"]}>
                                {({ getFieldValue, setFieldsValue }) => {
                                  const currentValue = getFieldValue("ledger_work_anniversary") || null;

                                  const handleWorkAnnivChange = (date: dayjs.Dayjs | null) => {
                                    setFieldsValue({ ledger_work_anniversary: date });
                                  };

                                  return (
                                    <DatePicker
                                      value={currentValue}
                                      onChange={handleWorkAnnivChange}
                                      style={{ width: "100%", borderRadius: "4px" }}
                                      format={["DD/MM/YYYY"]}
                                      disabledDate={(current) =>
                                        current && (current > dayjs() || current < dayjs().subtract(120, "years"))
                                      }
                                      onKeyDown={handleDOBKeyDown} // ✅ Reusing the function
                                    />
                                  );
                                }}
                              </Form.Item>
                            </Form.Item>
                          </Col>

                        </Row>
                      </div>
                    )}
                  </div>
                )}
              </Form.Item>






            </Row>


            {/* Address */}
            <Form.List name="addresses">
              {(fields, { add, remove }) => (
                <div
                  style={{
                    background: "#f5f5f5",
                    padding: "16px",
                    borderRadius: "8px",
                    marginBottom: "24px",
                  }}
                >
                  {/* Header and Add Button aligned */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                      marginBottom: 12,
                    }}
                  >
                    <h4 style={{ marginBottom: 0 }}>Fixed Addresses</h4>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                      size="middle"
                    >
                      Add address
                    </Button>
                  </div>

                  {fields.map(({ key, name, ...rest }) => (
                    <div
                      key={key}
                      style={{
                        marginBottom: 16,
                        padding: 16,
                        borderRadius: 6,
                        background: "#f5f5f5",
                      }}
                    >
                      <Row gutter={8}>
                        {/* Address Type  */}
                        <Col span={6}>
                          <Form.Item
                            {...rest}
                            name={[name, "type"]}
                            label="Type"
                            style={{ marginBottom: 8, backgroundColor: "#f5f5f5" }}
                          >
                            <Select
                              style={{ backgroundColor: "#f5f5f5" }}
                              placeholder="Select type"
                              dropdownStyle={{ backgroundColor: "#f5f5f5" }}
                              popupClassName="custom-select-dropdown"
                              className="custom-select"
                            >
                              <Option value="residence">Residence</Option>
                              <Option value="office">Office</Option>
                              <Option value="postal">Postal</Option>
                            </Select>
                          </Form.Item>
                        </Col>

                        {/* Address */}
                        <Col span={18}>
                          <Form.Item
                            {...rest}
                            name={[name, "address"]}
                            label="Address"
                            style={{ marginBottom: 8 }}
                          >
                            <Input placeholder="Full address" />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row gutter={8}>
                        {/* Landmark */}
                        <Col span={6}>
                          <Form.Item
                            {...rest}
                            name={[name, "landmark"]}
                            label="Landmark"
                            style={{ marginBottom: 8 }}
                          >
                            <Input placeholder="Enter landmark" />
                          </Form.Item>
                        </Col>

                        {/* Pincode */}
                        <Col span={6}>
                          <Form.Item
                            {...rest}
                            name={[name, "pincode"]}
                            label="Pincode"
                            style={{ marginBottom: 8 }}
                          >
                            <Form.Item noStyle dependencies={[[name, "pincode"]]}>
                              {({ getFieldValue, setFieldsValue }) => {
                                const currentValue = getFieldValue([name, "pincode"]) || "";

                                const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                                  let value = e.target.value;

                                  // Allow only digits
                                  value = value.replace(/[^0-9]/g, "");

                                  // Limit to 6 digits
                                  value = value.slice(0, 6);

                                  // Update form
                                  setFieldsValue({ [name]: { ...getFieldValue(name), pincode: value } });
                                };

                                return (
                                  <Input
                                    value={currentValue}
                                    maxLength={6}
                                    type="tel"
                                    style={{ background: '#f5f5f5' }}
                                    placeholder="Enter pincode"
                                    onChange={handleChange}
                                    onBlur={(e) => handlePincodeBlur(e.target.value, name)}
                                    suffix={
                                      <span style={{ fontSize: "12px", color: "#888" }}>
                                        {currentValue.length}/6
                                      </span>
                                    }
                                  />
                                );
                              }}
                            </Form.Item>
                          </Form.Item>
                        </Col>


                        {/* City */}
                        <Col span={6}>
                          <Form.Item
                            {...rest}
                            name={[name, "city"]}
                            label="City"
                            style={{ marginBottom: 8 }}
                          >
                            <Input placeholder="Enter city" />
                          </Form.Item>
                        </Col>

                        {/* State */}
                        <Col span={6}>
                          <Form.Item
                            {...rest}
                            name={[name, "state"]}
                            label="State"
                            style={{ marginBottom: 8 }}
                          >
                            <Input placeholder="Enter state" />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row gutter={8} align="middle">

                        {/* Country */}
                        <Col span={12}>
                          <Form.Item
                            {...rest}
                            name={[name, "country"]}
                            label="Country"
                            style={{ marginBottom: 0 }}
                          >
                            <Input placeholder="Enter country" />
                          </Form.Item>
                        </Col>

                        <Col span={12} style={{ textAlign: "right" }}>
                          <Button
                            danger
                            icon={<MinusCircleOutlined />}
                            onClick={() => remove(name)}
                          >
                            Remove address
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </div>
              )}
            </Form.List>

            {/* Phones */}
            <Form.List name="phones">
              {(fields, { add, remove }) => (
                <div
                  style={{
                    background: "#f5f5f5",
                    padding: "16px",
                    borderRadius: "6px",
                    marginBottom: "24px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                      marginBottom: 12,
                    }}
                  >
                    <h4 style={{ marginBottom: 0 }}>Phone Numbers</h4>
                    <Button
                      type="dashed"
                      // onClick={() => add()}
                      onClick={() => {
                        // ✅ Get ledger_first_name value
                        const ledgerFirstName = form.getFieldValue("ledger_first_name") || "";
                        const ledgerLastName = form.getFieldValue("ledger_last_name") || "";
                        const ledgerDesignation = form.getFieldValue("ledger_designation") || "";
                        const ledgerEmail = form.getFieldValue("ledger_email") || "";

                        // Add new contact with pre-filled values
                        add({
                          first_name: ledgerFirstName,
                          last_name: ledgerLastName,
                          designation: ledgerDesignation,
                          email: ledgerEmail,
                        });
                      }}
                      icon={<PlusOutlined />}
                      size="middle"
                    >
                      Add contact
                    </Button>
                  </div>

                  {fields.map(({ key, name, ...rest }) => (
                    <>
                      <Row key={key} gutter={16} align="middle" style={{ marginBottom: 8 }}>
                        {/* First Name */}
                        {/* <Col span={8}>
                          <Form.Item
                            {...rest}
                            name={[name, "first_name"]}
                            label="First Name"
                            rules={[{ required: true, message: "First name required" }]}
                          >
                            <Input placeholder="First name" />
                          </Form.Item>
                        </Col> */}

                        {/* First Name */}
                        <Col span={8}>
                          <Form.Item
                            {...rest}
                            name={[name, "first_name"]}
                            label="First Name"
                            rules={[{ required: true, message: "First name required" }]}
                          >
                            <Input
                              placeholder="First name"
                              maxLength={50}
                              onChange={(e) => {
                                let value = e.target.value;

                                // Allow only alphabets and space
                                value = value.replace(/[^a-zA-Z ]/g, "");

                                // Limit to 50 characters
                                value = value.slice(0, 50);

                                // Update this nested field safely
                                const phones = form.getFieldValue("phones") || [];
                                phones[name] = {
                                  ...phones[name],
                                  first_name: value,
                                };
                                form.setFieldsValue({ phones });
                              }}
                            />
                          </Form.Item>
                        </Col>

                        {/* Last Name */}
                        <Col span={8}>
                          <Form.Item
                            {...rest}
                            name={[name, "last_name"]}
                            label="Last Name"
                            rules={[{ required: true, message: "Last name required" }]}
                          >
                            <Input
                              placeholder="Last name"
                              maxLength={50}
                              onChange={(e) => {
                                let value = e.target.value;

                                // Allow only alphabets and space
                                value = value.replace(/[^a-zA-Z ]/g, "");

                                // Limit to 50 characters
                                value = value.slice(0, 50);

                                // Update this nested field safely
                                const phones = form.getFieldValue("phones") || [];
                                phones[name] = {
                                  ...phones[name],
                                  last_name: value,
                                };
                                form.setFieldsValue({ phones });
                              }}
                            />
                          </Form.Item>
                        </Col>


                        {/* Designation */}
                        <Col span={8}>
                          <Form.Item {...rest}
                            label="Designation"
                            name={[name, "designation"]}>
                            <Select
                              showSearch
                              placeholder="Select your occupation"
                              value={selectedDesignation}
                              onChange={handleOccupationChange}
                              options={designationOptions}
                              filterOption={(input, option) =>
                                (option?.label as string).toLowerCase().includes(input.toLowerCase())
                              }
                              style={{ width: '100%' }}
                            />
                          </Form.Item>
                        </Col>


                        {/* Mobile Number */}
                        <Col span={8}>
                          <Form.Item
                            {...rest}
                            name={[name, "number"]}
                            label="Mobile Number"
                            rules={[
                              { required: true, message: "Mobile number required" },
                              { pattern: /^[0-9]{10}$/, message: "Must be 10 digits" },
                            ]}
                          >
                            <Input
                              placeholder="Mobile Number"
                              maxLength={10}
                              onChange={(e) => {
                                const value = e.target.value; // ✅ No cleaning
                                const phones = form.getFieldValue("phones") || [];
                                phones[name] = {
                                  ...phones[name], // Keep all existing fields
                                  number: value,   // Only update this field
                                };
                                form.setFieldsValue({ phones });
                              }}
                            />
                          </Form.Item>
                        </Col>


                        {/* Email */}
                        <Col span={8}>
                          <Form.Item
                            {...rest}
                            name={[name, "email"]}
                            label="Email"
                            rules={[
                              { type: "email", message: "Please enter a valid email address" }
                            ]}
                          >
                            <Form.Item noStyle dependencies={[[name, "email"]]}>
                              {({ getFieldValue, setFieldsValue }) => {
                                const currentValue = getFieldValue(["phones", name, "email"]) || "";

                                const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                                  let value = e.target.value;

                                  // Remove spaces
                                  value = value.replace(/\s/g, "");

                                  // Convert to lowercase
                                  value = value.toLowerCase();

                                  // Limit to 100 chars
                                  value = value.slice(0, 100);

                                  // Update this nested field safely
                                  const phones = getFieldValue("phones") || [];
                                  phones[name] = {
                                    ...phones[name],
                                    email: value,
                                  };
                                  setFieldsValue({ phones });
                                };

                                return (
                                  <Input
                                    value={currentValue}
                                    maxLength={100}
                                    onChange={handleChange}
                                    placeholder="example@email.com"
                                    suffix={
                                      <span style={{ fontSize: "12px", color: "#888" }}>
                                        {currentValue.length}/100
                                      </span>
                                    }
                                  />
                                );
                              }}
                            </Form.Item>
                          </Form.Item>
                        </Col>


                        {/* Label */}
                        {/* <Col span={8}>
                          <Form.Item {...rest} name={[name, "label"]}
                            label="Label"
                          >
                            <Input placeholder="Label" />
                          </Form.Item>
                        </Col> */}

                        {/* Contact Type */}
                        {/* <Col span={8}>
                          <Form.Item
                            {...rest}
                            name={[name, "type"]}
                            label="Contact Type"
                            rules={[{ required: true, message: "Select type" }]}
                          >
                            <Select placeholder="Select Contact Type">
                              <Select.Option value="mobile">Mobile</Select.Option>
                              <Select.Option value="phone">Phone</Select.Option>
                            </Select>
                          </Form.Item>
                        </Col> */}

                        {/* STD Code */}
                        <Col span={8}>
                          <Form.Item
                            {...rest}
                            name={[name, "std_code"]}
                            label="STD Code"
                            rules={[
                              { required: true, message: "STD code required" },
                              { pattern: /^[0-9]{1,5}$/, message: "Max 5 digits" },
                            ]}
                          >
                            <Input
                              placeholder="STD"
                              maxLength={5}
                              onChange={(e) => {
                                let value = e.target.value;
                                // ✅ Allow only digits
                                value = value.replace(/\D/g, "");
                                const phones = form.getFieldValue("phones") || [];
                                phones[name] = {
                                  ...phones[name], // Keep all existing fields
                                  std_code: value, // Only update this field
                                };
                                form.setFieldsValue({ phones });
                              }}
                            />
                          </Form.Item>
                        </Col>

                        {/* Phone Number */}
                        <Col span={8}>
                          <Form.Item
                            {...rest}
                            name={[name, "std_phone"]}
                            label="Telephone Number"
                            rules={[
                              { required: true, message: "STD phone required" },
                              { pattern: /^[0-9]{6,10}$/, message: "6–10 digits" },
                            ]}
                          >
                            <Input
                              placeholder="Enter Telephone Number"
                              maxLength={10}
                              onChange={(e) => {
                                let value = e.target.value;
                                value = value.replace(/\D/g, "");
                                const phones = form.getFieldValue("phones") || [];
                                phones[name] = {
                                  ...phones[name],   // Keep all existing fields
                                  std_phone: value,  // Only update this field
                                };
                                form.setFieldsValue({ phones });
                              }}
                            />
                          </Form.Item>
                        </Col>


                        <Col span={8}>
                          <Form.Item
                            {...rest}
                            name={[name, "sms"]}
                            label="SMS"
                            rules={[{ required: true, message: "Select SMS" }]}
                          >
                            <Select placeholder="Select  SMS">
                              <Select.Option value="Yes">Yes</Select.Option>
                              <Select.Option value="No">No</Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row justify="end">
                        {/* Remove button */}
                        <Col span={3} style={{ display: 'flex', alignItems: 'center' }}>
                          <Tooltip title="Remove contact">
                            <Button
                              danger
                              icon={<MinusCircleOutlined />}
                              onClick={() => remove(name)}
                            >
                              Remove contact
                            </Button>
                          </Tooltip>
                        </Col>
                      </Row>
                    </>
                  ))}
                </div>
              )}
            </Form.List>


            {/* Banks section */}
            <Form.List name="banks">
              {(fields, { add, remove }) => (
                <div
                  style={{
                    background: "#f5f5f5", // background color for entire block
                    padding: "16px",
                    borderRadius: "8px",
                    marginBottom: "24px",
                    // border: '1px solid #e0e0e0',
                  }}
                >
                  {/* Heading + Add Button aligned right */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                      marginBottom: 12,
                    }}
                  >
                    <h4 style={{ marginBottom: 0 }}>Bank Details</h4>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                      size="middle"
                    >
                      Add bank
                    </Button>
                  </div>

                  {/* All bank fields */}
                  {fields.map(({ key, name, ...rest }) => (
                    <Space
                      key={key}
                      align="baseline"
                      style={{ display: "flex", marginBottom: 8 }}
                    >
                      {/* IFSC */}
                      <Form.Item
                        {...rest}
                        name={[name, "ifsc"]}
                        label="IFSC Code"
                        style={{ marginBottom: 0 }}
                        rules={[{ required: true, message: "IFSC required" }]}
                      >
                        <Input
                          placeholder="Enter IFSC code"
                          maxLength={11}
                          onBlur={async (e) => {
                            const ifsc = e.target.value.trim().toUpperCase(); // IFSCs are uppercase
                            if (!ifsc) return;

                            try {
                              const response = await apiRequest({
                                url: "check-ifsc",
                                method: "get",
                                params: { ifsc }, // sent as query param: ?ifsc=XXXX
                              });

                              if (response?.data) {
                                const index =
                                  typeof name === "string"
                                    ? parseInt(name, 10)
                                    : name;
                                form.setFields([
                                  {
                                    name: ["banks", index, "bank_name"],
                                    value: response.data.bankName,
                                  },
                                  {
                                    name: ["banks", index, "address"],
                                    value: response.data.address,
                                  },
                                ]);

                                console.log("name:", name, typeof name);

                                console.log("IFSC valid:", response.data);
                              } else {
                                showError(response?.message || "Invalid IFSC");
                              }
                            } catch (err) {
                              showError("Failed to validate IFSC");
                              console.error(err);
                            }
                          }}
                        />
                      </Form.Item>

                      {/* Bank name  */}
                      <Form.Item
                        {...rest}
                        name={[name, "bank_name"]}
                        label="Bank Name"
                        style={{ marginBottom: 0 }}
                        rules={[{ required: true, message: "Bank name required" }]}
                      >
                        <Input placeholder="Bank name" />
                      </Form.Item>

                      {/* Bank Address */}
                      <Form.Item
                        {...rest}
                        label="Bank Address"
                        name={[name, "address"]}
                        style={{ marginBottom: 0 }}
                      >
                        <Input placeholder="Bank address" />
                      </Form.Item>

                      {/* Account no */}
                      <Form.Item
                        {...rest}
                        name={[name, "acc_no"]}
                        label="Account Number"
                        style={{ marginBottom: 0 }}
                        rules={[
                          { required: true, message: "Account No required" },
                          {
                            validator: (_, value) => {
                              if (!value) return Promise.resolve();

                              const accountNumberRegex = /^[0-9]{9,18}$/;

                              if (!accountNumberRegex.test(value)) {
                                return Promise.reject(
                                  new Error("Account number must be 9 to 18 digits (only numbers)")
                                );
                              }

                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <Input placeholder="Account number" />
                      </Form.Item>


                      {/* Holder Name */}
                      <Form.Item
                        {...rest}
                        name={[name, "holder_name"]}
                        style={{ marginBottom: 0 }}
                        label="Holder Name"
                      >
                        <Input placeholder="Holder Name" />
                      </Form.Item>

                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                </div>
              )}
            </Form.List>


            {/* Discounts Section - Collapsible */}
            <Form.Item shouldUpdate noStyle>
              {(form) => {
                const categoriesValue = form.getFieldValue("categories") || [];

                return (
                  <div
                    style={{
                      background: "#f5f5f5",
                      padding: "16px",
                      borderRadius: "6px",
                      marginBottom: "24px",
                    }}
                  >
                    {/* Header with Collapse Button */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: discountCollapsed ? 0 : 12,
                      }}
                    >
                      <h4 >Discounts</h4>

                      <Button
                        type="text"
                        size="small"
                        icon={discountCollapsed ? <CaretDownOutlined /> : <CaretUpOutlined />}
                        onClick={() => setDiscountCollapsed(!discountCollapsed)}
                      >
                        {discountCollapsed ? "Add" : "Close"}
                      </Button>
                    </div>

                    {/* Table - Only show when not collapsed */}
                    {!discountCollapsed && (
                      <Table
                        rowKey="category_id"
                        dataSource={categoriesValue}
                        pagination={false}
                        bordered
                        size="small"
                        columns={[
                          {
                            title: "Category Name",
                            dataIndex: "category_name",
                            key: "category_name",
                            width: "40%",
                            render: (text, record, index) => (
                              <>
                                {/* ✅ Hidden fields */}
                                <Form.Item name={["categories", index, "category_id"]} hidden>
                                  <Input />
                                </Form.Item>
                                <Form.Item name={["categories", index, "category_name"]} hidden>
                                  <Input />
                                </Form.Item>
                                <Form.Item name={["categories", index, "category_status"]} hidden>
                                  <Input />
                                </Form.Item>

                                {/* Display category name */}
                                <span>{text || "-"}</span>
                              </>
                            ),
                          },
                          {
                            title: "Discount (%)",
                            key: "discount",
                            width: "30%",
                            render: (_, record, index) => (
                              <Form.Item
                                name={["categories", index, "discount"]}
                                style={{ margin: 0 }}
                              >
                                <InputNumber
                                  min={0}
                                  max={100}
                                  placeholder="0"
                                  style={{ width: "100%" }}
                                />
                              </Form.Item>
                            ),
                          },
                          {
                            title: "Special Discount (%)",
                            key: "special_discount",
                            width: "30%",
                            render: (_, record, index) => (
                              <Form.Item
                                name={["categories", index, "special_discount"]}
                                style={{ margin: 0 }}
                              >
                                <InputNumber
                                  min={0}
                                  max={100}
                                  placeholder="0"
                                  style={{ width: "100%" }}
                                />
                              </Form.Item>
                            ),
                          },
                        ]}
                      />
                    )}
                  </div>
                );
              }}
            </Form.Item>


            {/* payroll */}
            <Form.List name="payrolls">
              {(fields, { add, remove }) => (
                <div
                  style={{
                    background: "#f5f5f5", // full background for whole block
                    padding: "16px",
                    borderRadius: "6px",
                    marginBottom: "24px",
                  }}
                >
                  {/* Header + Add button aligned right */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                      marginBottom: 12,
                    }}
                  >
                    <h4 style={{ marginBottom: 0 }}>Payroll Master</h4>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                      size="middle"
                    >
                      Add Payroll
                    </Button>
                  </div>

                  {/* All link entries */}
                  {fields.map(({ key, name, ...rest }) => (
                    <>
                      <Row gutter={16}>
                        {/* Check-In Time */}
                        <Col span={12}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_check_in"]}
                            label="Check-In Time"
                            style={{ marginBottom: 0, width: "100%" }}
                            rules={[{ required: true, message: "Check-In Time is required" }]}
                          >
                            <TimePicker format="hh:mm A" style={{ width: "99%", padding: "5px", background: "#f5f5f5", margin: "5px" }}
                              className="simple-input-radius-with-border" use12Hours />
                          </Form.Item>
                        </Col>

                        {/* check-out  */}
                        <Col span={12}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_check_out"]}
                            label="Check-Out Time"
                            rules={[{ required: true, message: 'Please enter Check-Out time' }]}
                          >
                            <TimePicker format="hh:mm A" style={{ width: "99%", padding: "5px", background: "#f5f5f5", margin: "5px" }}
                              className="simple-input-radius-with-border" use12Hours />
                          </Form.Item>
                        </Col>
                        {/* Working Hours */}
                        <Col span={12}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_working_hours"]}
                            className="px-8"
                            label="Working Hours"
                            rules={[{ required: true, message: 'Please enter Working Hours' }]}
                          >
                            <Input placeholder="e.g., 8 hours" disabled />
                          </Form.Item>
                        </Col>


                        {/* Days of Working */}
                        <Col span={12}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_days_of_working"]}
                            className="px-8"
                            label="Days of Working"
                            rules={[
                              { required: true, message: 'Please select Days of Working' },
                            ]}
                          >
                            <Select
                              mode="multiple"
                              placeholder="e.g., Monday to Friday"
                              showSearch
                              optionFilterProp="children"
                              allowClear
                              style={{ background: "#f5f5f5" }}
                              className='input-bordor-radius-with-border'
                            >
                              <Select.Option value="Monday">Monday</Select.Option>
                              <Select.Option value="Tuesday">Tuesday</Select.Option>
                              <Select.Option value="Wednesday">Wednesday</Select.Option>
                              <Select.Option value="Thursday">Thursday</Select.Option>
                              <Select.Option value="Friday">Friday</Select.Option>
                              <Select.Option value="Saturday">Saturday</Select.Option>
                              <Select.Option value="Sunday">Sunday</Select.Option>
                            </Select>
                          </Form.Item>

                        </Col>

                        {/* Days Off */}
                        <Col span={12}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_days_off"]}
                            className="px-8"
                            label="Days of Working"
                            rules={[
                              { required: true, message: 'Please select Days off' },
                            ]}
                          >
                            <Select
                              mode="multiple"
                              placeholder="e.g., Any day"
                              showSearch
                              optionFilterProp="children"
                              allowClear
                              style={{ background: "#f5f5f5" }}
                              className='input-bordor-radius-with-border'
                            >
                              <Select.Option value="Monday">Monday</Select.Option>
                              <Select.Option value="Tuesday">Tuesday</Select.Option>
                              <Select.Option value="Wednesday">Wednesday</Select.Option>
                              <Select.Option value="Thursday">Thursday</Select.Option>
                              <Select.Option value="Friday">Friday</Select.Option>
                              <Select.Option value="Saturday">Saturday</Select.Option>
                              <Select.Option value="Sunday">Sunday</Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>

                        {/* Date of Joining */}
                        <Col span={12}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_date_of_joining"]}
                            label="Date of Joining"
                            rules={[{ required: true, message: 'Please select Date of Joining' }]}
                          >
                            <DatePicker style={{ width: '100%', padding: "5px", background: "#f5f5f5", margin: "5px" }} className="simple-input-radius-with-border" format="DD-MM-YYYY" />
                          </Form.Item>
                        </Col>

                        {/* Lunch-In Time */}
                        <Col span={12}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_lunch_in"]}
                            label="Lunch-In Time"
                            style={{ marginBottom: 0, width: "100%" }}
                            rules={[{ required: true, message: "Lunch-In Time is required" }]}
                          >
                            <TimePicker format="hh:mm A" style={{ width: "99%", padding: "5px", background: "#f5f5f5", margin: "5px" }}
                              className="simple-input-radius-with-border" use12Hours />
                          </Form.Item>
                        </Col>

                        {/* Lunch-out  */}
                        <Col span={12}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_lunch_out"]}
                            label="Lunch-Out Time"
                            rules={[{ required: true, message: 'Please enter Lunch-Out time' }]}
                          >
                            <TimePicker format="hh:mm A" style={{ width: "99%", padding: "5px", background: "#f5f5f5", margin: "5px" }}
                              className="simple-input-radius-with-border" use12Hours />
                          </Form.Item>
                        </Col>

                        {/* Salary */}
                        <Col span={12}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_salary"]}
                            className="px-8"
                            label="Salary"
                            rules={[{ required: true, message: 'Please enter Salary' }]}
                          >
                            <Input type="number" placeholder="e.g., 30000" />
                          </Form.Item>
                        </Col>

                        {/* Type of Work */}
                        <Col span={12}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_type_of_work"]}
                            className="px-9"
                            label="Type of Work"
                            rules={[
                              { required: true, message: 'Please enter Type of Work' },
                              { max: 50, message: 'Maximum 30 characters allowed' },
                            ]}
                          >
                            {/* <Input showCount maxLength={30} placeholder="e.g., Full-time" /> */}
                            <Select
                              showSearch
                              placeholder="Select type of work"
                              optionFilterProp="label"
                              style={{ width: '100%', padding: "5px", background: "#f5f5f5", margin: "5px" }}
                              filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                              }
                              options={typeOfWorkOptions}
                            />
                          </Form.Item>
                        </Col>

                        {/* Increment Period */}
                        <Col span={12}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_increment_period"]}
                            className="px-8"
                            label="Increment Period"
                            rules={[
                              { required: true, message: 'Please select Increment Period' },
                            ]}
                          >
                            <Select
                              placeholder="Select increment period"
                              showSearch
                              optionFilterProp="children"
                              allowClear
                              style={{ padding: "5px", background: "#f5f5f5" }}
                            >
                              <Select.Option value="Monthly">Monthly</Select.Option>
                              <Select.Option value="Quarterly">Quarterly</Select.Option>
                              <Select.Option value="Annually">Annually</Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col span={4} style={{ paddingRight: 0 }}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_increment_type"]}
                            label="Type"
                            rules={[{ required: true, message: 'Please select type' }]}
                          >
                            <Select placeholder="Select type" className='left-rounded' style={{ background: "#f5f5f5", }}>
                              <Option value="percentage">Percentage (%)</Option>
                              <Option value="rupees">Rupees (₹)</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={8} style={{ paddingLeft: 0 }}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_increment_value"]}
                            label="Value"
                            rules={[{ required: true, message: 'Please enter value' }]}
                          >
                            <Input type="number" placeholder="Enter value" className='right-rounded' />
                          </Form.Item>
                        </Col>

                        {/* Late Arrival Allowance (Times) */}
                        <Col span={6} style={{ paddingLeft: 0, }}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_late_allowance_time"]}
                            label="Late Arrival Allowance (Times)"
                            rules={[{ required: true, message: 'Please enter late allowance' }]}
                          >
                            <TimePicker format="hh:mm A" style={{ width: "100%", padding: "5px", background: "#f5f5f5", margin: "5px" }}
                              className="simple-input-radius-with-border" use12Hours />
                          </Form.Item>

                        </Col>

                        {/* Apply Half Day if Late exceeds Allowance? */}
                        <Col span={6} style={{ paddingLeft: 0 }}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_late_apply_half_day"]}
                            className="px-8"
                            label="Apply Half Day if Late exceeds Allowance?"
                            valuePropName="checked"
                          >
                            <Switch />
                          </Form.Item>
                        </Col>

                        {/* Deduct Commission if Late exceeds Allowance? */}
                        <Col span={6} style={{ paddingLeft: 0 }}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_late_deduct_commission"]}
                            className="px-8"
                            label="Deduct Commission if Late exceeds Allowance?"
                            valuePropName="checked"
                          >
                            <Switch onChange={setShowCommissionOption} />
                          </Form.Item>
                        </Col>

                        {/* Commission Deduction (%) */}
                        <Col span={6} style={{ paddingLeft: 0 }}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_late_commission_percentage"]}
                            className="px-8"
                            label="Commission Deduction (%)"
                            rules={[
                              {
                                required: showCommissionOption,
                                message: 'Please select a percentage',
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select commission percentage"
                              disabled={!showCommissionOption}
                            >
                              {[5, 10, 15, 20, 25, 50, 100].map((percent) => (
                                <Option key={percent} value={percent}>
                                  {percent}%
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>


                        {/* Early go */}
                        {/* Early Go Allowance (Time) */}
                        <Col span={6} style={{ paddingLeft: 0 }}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_early_go_allowance_time"]}
                            className="px-8"
                            label="Early Go Allowance (Time)"
                            rules={[{ required: true, message: 'Please enter early go allowance time' }]}
                          >
                            <TimePicker
                              format="hh:mm A"
                              style={{ width: "100%", padding: "5px", background: "#f5f5f5", margin: "5px" }}
                              className="simple-input-radius-with-border"
                              use12Hours
                            />
                          </Form.Item>
                        </Col>

                        {/* Apply Half Day if Early Go exceeds Allowance? */}
                        <Col span={6} style={{ paddingLeft: 0 }}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_early_apply_half_day"]}
                            className="px-8"
                            label="Apply Half Day if Early Go exceeds Allowance?"
                            valuePropName="checked"
                          >
                            <Switch />
                          </Form.Item>
                        </Col>

                        {/* Deduct Commission if Early Go exceeds Allowance? */}
                        <Col span={6} style={{ paddingLeft: 0 }}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_early_deduct_commission"]}
                            className="px-8"
                            label="Deduct Commission if Early Go exceeds Allowance?"
                            valuePropName="checked"
                          >
                            <Switch onChange={setShowEarlyGoCommissionOption} />
                          </Form.Item>
                        </Col>

                        {/* Commission Deduction for Early Go (%) */}
                        <Col span={6} style={{ paddingLeft: 0 }}>
                          <Form.Item
                            {...rest}
                            name={[name, "payroll_early_commission_percentage"]}
                            className="px-8"
                            label="Commission Deduction for Early Go (%)"
                            rules={[
                              {
                                required: showEarlyGoCommissionOption,
                                message: 'Please select a percentage',
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select commission percentage"
                              disabled={!showEarlyGoCommissionOption}
                            >
                              {[5, 10, 15, 20, 25, 50, 100].map((percent) => (
                                <Option key={percent} value={percent}>
                                  {percent}%
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Row>
                    </>
                  ))}
                </div>
              )}
            </Form.List>




            <Form.Item shouldUpdate noStyle>
              {(form) => (
                <div style={{
                  background: "#f5f5f5",
                  width: "99%",
                  margin: "0 auto 20px auto",
                  padding: "24px 8px",
                  borderRadius: "6px",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}>
                  <Row
                    gutter={16}
                    style={{
                      margin: 0,
                      alignItems: "center",
                    }}
                  >
                    <Col span={12}>
                      <span><h4 style={{ margin: "10px 0 10px 0", padding: 0 }}>Other </h4></span>
                    </Col>

                    <Col span={12} style={{ textAlign: "right" }}>
                      <Button
                        type="text"
                        size="small"
                        icon={otherCollapsed ? <CaretUpOutlined /> : <CaretDownOutlined />}
                        onClick={() => setOtherCollapsed(!otherCollapsed)}
                      >
                        {otherCollapsed ? "Hide" : "Add"}
                      </Button>
                    </Col>
                  </Row>
                  {/* Company Details block */}
                  {otherCollapsed && (
                    <div
                      style={{
                        background: "#f5f5f5",
                        borderRadius: "6px",
                        marginTop: 16,
                        position: "relative",
                      }}
                    >
                      <Row gutter={16}>
                        {/* Reserve Fund */}
                        <Col span={8}>
                          <Form.Item
                            name="ledger_reserve_fund"
                            label="Reserve Fund Amount (In %)"
                          >
                            <Input
                              inputMode="decimal"
                              onKeyDown={(e) => decimalInputKeyDown(e, 3, 2, 100)}
                              onPaste={(e) => decimalInputPaste(e, 3, 2, 100)}
                            />
                          </Form.Item>
                        </Col>


                        {/* TDS */}
                        <Col span={8}>
                          <Form.Item
                            name="ledger_tds"
                            label="TDS Amount (In %)"
                          >
                            <Input
                              inputMode="decimal"
                              onKeyDown={(e) => decimalInputKeyDown(e, 3, 2, 100)}
                              onPaste={(e) => decimalInputPaste(e, 3, 2, 100)}
                            />
                          </Form.Item>
                        </Col>

                        {/* Bill to bill */}
                        <Col span={8}>
                          <Form.Item
                            name="ledger_bill_to_bill"
                            label="Bill To Bill"
                            rules={[{ required: true, message: "Please select Yes or No" }]}
                          >
                            <Select placeholder="Select Yes or No" onChange={onBillToBillChange}>
                              <Select.Option value="Yes">Yes</Select.Option>
                              <Select.Option value="No">No</Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>

                        {/* Bill to bill table */}
                        {showLinks && (
                          <Col span={24}>
                            <Form.List name="bill-to-bill">
                              {(fields, { add, remove }) => (
                                <div
                                  style={{
                                    background: "#f5f5f5",
                                    padding: "16px",
                                    borderRadius: "6px",
                                    marginBottom: "24px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "baseline",
                                      marginBottom: 12,
                                    }}
                                  >
                                    <h4 style={{ marginBottom: 0 }}>Bill to Bill</h4>
                                    <Button
                                      type="dashed"
                                      onClick={() => add()}
                                      icon={<PlusOutlined />}
                                      size="middle"
                                    >
                                      Add Bill to Bill
                                    </Button>
                                  </div>

                                  {fields.map(({ key, name, ...rest }) => (
                                    <Space
                                      key={key}
                                      align="baseline"
                                      style={{
                                        display: "flex",
                                        marginBottom: 8,
                                      }}
                                    >
                                      <Form.Item
                                        {...rest}
                                        name={[name, "Bill to Bill"]}
                                        label="Name"
                                        style={{ marginBottom: 0 }}
                                        rules={[{ required: true, message: "Name is required" }]}
                                      >
                                        <Input placeholder="Name" />
                                      </Form.Item>

                                      <Form.Item
                                        {...rest}
                                        name={[name, "description"]}
                                        label="Description"
                                        style={{ marginBottom: 0 }}
                                      >
                                        <Input placeholder="Description" />
                                      </Form.Item>

                                      <MinusCircleOutlined onClick={() => remove(name)} />
                                    </Space>
                                  ))}
                                </div>
                              )}
                            </Form.List>
                          </Col>
                        )}

                        {/* Credit Limit Day */}
                        <Col span={8}>
                          <Form.Item name="ledger_credit_limit_day" label="Credit Limit Day">
                            <Input type="number"
                              min={0}
                              onKeyDown={(e) => {
                                if (e.key === '-' || e.key === '+') {
                                  e.preventDefault();
                                }
                              }} />
                          </Form.Item>
                        </Col>

                        {/*  Credit Limit Amount */}
                        <Col span={8}>
                          <Form.Item
                            name="ledger_credit_limit_amount"
                            label="Credit Limit Amount"
                          >
                            <Input type="number"
                              min={0}
                              onKeyDown={(e) => {
                                if (e.key === '-' || e.key === '+') {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>

                        {/* Opening Balance */}
                        <Col span={8} >
                          <Form.Item name="ledger_opening_balance" label="Opening Balance">
                            <Input type="number"
                              min={0}
                              onKeyDown={(e) => {
                                if (e.key === '-' || e.key === '+') {
                                  e.preventDefault();
                                }
                              }} />
                          </Form.Item>
                        </Col>

                        {/* Opening Type */}
                        <Col span={8}>
                          <Form.Item name="ledger_opening_type" label="Opening Type">
                            <Select allowClear placeholder="Select type">
                              <Option value="Dr">Debit</Option>
                              <Option value="Cr">Credit</Option>
                            </Select>
                          </Form.Item>
                        </Col>

                        {/* Intrest rate */}
                        <Col span={8}>
                          <Form.Item name="ledger_interest_rate" label="Interest Rate">
                            <Input type="number"
                              min={0}
                              onKeyDown={(e) => {
                                if (e.key === '-' || e.key === '+') {
                                  e.preventDefault();
                                }
                              }} />
                          </Form.Item>
                        </Col>

                        {/* Intrest Style */}
                        <Col span={8}>
                          <Form.Item name="ledger_interest_style" label="Interest Style">
                            <Select allowClear placeholder="Select style">
                              <Option value="simple">Simple</Option>
                              <Option value="compound">Compound</Option>
                            </Select>
                          </Form.Item>
                        </Col>

                      </Row>

                    </div>
                  )}
                </div>
              )}
            </Form.Item>

            {/* </Row> */}

            <Row gutter={16}>


              {/* Email */}
              <Col span={8}>
                <Form.Item
                  name="ledger_email"
                  label="Email"
                  rules={[
                    {
                      type: 'email',
                      message: 'Please enter a valid email address'
                    }
                  ]}
                >
                  <Form.Item noStyle dependencies={["ledger_email"]}>
                    {({ getFieldValue, setFieldsValue }) => {
                      const currentValue = getFieldValue("ledger_email") || "";

                      const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                        let value = e.target.value;

                        // Remove spaces
                        value = value.replace(/\s/g, "");

                        // Convert to lowercase
                        value = value.toLowerCase();

                        // Limit 100 chars
                        value = value.slice(0, 100);

                        // ✅ Sync with first phone contact's email
                        const phones = getFieldValue("phones") || [];
                        if (phones.length > 0) {
                          phones[0] = {
                            ...phones[0],
                            email: value,
                          };
                          setFieldsValue({
                            ledger_email: value,
                            phones: phones
                          });
                        } else {
                          setFieldsValue({ ledger_email: value });
                        }
                      };

                      return (
                        <Input
                          value={currentValue}
                          maxLength={100}
                          onChange={handleChange}
                          placeholder="example@email.com"
                          suffix={
                            <span style={{ fontSize: "12px", color: "#888" }}>
                              {currentValue.length}/100
                            </span>
                          }
                        />
                      );
                    }}
                  </Form.Item>
                </Form.Item>
              </Col>



              {/* ledger_status */}
              <Col span={8}>
                <Form.Item name="ledger_status" label="Status">
                  <Select allowClear placeholder="Select status">
                    <Option value={1}>Active</Option>
                    <Option value={0}>Inactive</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            {/* Links */}
            <Form.List name="links">
              {(fields, { add, remove }) => (
                <div
                  style={{
                    background: "#f5f5f5", // full background for whole block
                    padding: "16px",
                    borderRadius: "6px",
                    marginBottom: "24px",
                  }}
                >
                  {/* Header + Add button aligned right */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                      marginBottom: 12,
                    }}
                  >
                    <h4 style={{ marginBottom: 0 }}>Links</h4>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                      size="middle"
                    >
                      Add link
                    </Button>
                  </div>

                  {/* All link entries */}
                  {fields.map(({ key, name, ...rest }) => (
                    <Space
                      key={key}
                      align="baseline"
                      style={{
                        display: "flex",
                        marginBottom: 8,
                      }}
                    >
                      {/* Link or name */}
                      <Form.Item
                        {...rest}
                        name={[name, "link"]}
                        label="Link or Name"
                        style={{ marginBottom: 0 }}
                        rules={[{ required: true, message: "Link is required" }]}
                      >
                        <Input placeholder="Link or name" />
                      </Form.Item>

                      {/* Description */}
                      <Form.Item
                        {...rest}
                        name={[name, "description"]}
                        label="Description"
                        style={{ marginBottom: 0 }}
                      >
                        <Input placeholder="Description" />
                      </Form.Item>

                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                </div>
              )}
            </Form.List>




            {/* documents */}
            <Form.List name="documents">
              {(fields, { add, remove }) => (
                <div
                  style={{
                    background: "#f5f5f5",
                    padding: "16px",
                    borderRadius: "6px",
                    marginBottom: "24px",
                  }}
                >
                  {/* Header + Add button */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                      marginBottom: 12,
                    }}
                  >
                    <h4 style={{ marginBottom: 0 }}>Documents</h4>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                      size="middle"
                    >
                      Add document
                    </Button>
                  </div>

                  {fields.map(({ key, name, ...rest }) => (
                    <Row gutter={16}>
                      {/* Document Type */}
                      <Col span={8}>
                        <Form.Item
                          name={[name, "document_type"]}
                          label="Document Type"
                          rules={[
                            {
                              required: true,
                              message: "Please select document type",
                            },
                          ]}
                        >
                          <Select allowClear placeholder="Select document type">
                            <Option value="aadhaar">Aadhaar Card</Option>
                            <Option value="pan">PAN Card</Option>
                            <Option value="10th">10th Certificate</Option>
                            <Option value="12th">12th Certificate</Option>
                            <Option value="graduation">
                              Graduation Certificate
                            </Option>
                            <Option value="other">Other</Option>
                          </Select>
                        </Form.Item>
                      </Col>

                      {/* Document Name */}
                      <Col span={8}>
                        <Form.Item shouldUpdate noStyle>
                          {({ getFieldValue, setFieldsValue }) => {
                            const value =
                              getFieldValue([name, "document_name"]) || "";

                            return (
                              <Form.Item
                                {...rest}
                                name={[name, "document_name"]}
                                label="Document Name"
                                rules={[
                                  {
                                    required: true,
                                    message: "Document name is required",
                                  },
                                  {
                                    pattern: /^[A-Za-z0-9]+$/,
                                    message: "Only alphabets are allowed",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Document Name"
                                  maxLength={25}
                                  showCount
                                  value={value}
                                  onChange={(e) => {
                                    // Sirf alphabets allow karo (space, numbers, special chars remove)
                                    let onlyAlphaNum = e.target.value.replace(/[^A-Za-z0-9]/g, "");

                                    // First letter capitalize
                                    if (onlyAlphaNum.length > 0) {
                                      onlyAlphaNum =
                                        onlyAlphaNum.charAt(0).toUpperCase() +
                                        onlyAlphaNum.slice(1);
                                    }

                                    // Field value update karo
                                    setFieldsValue({
                                      documents: {
                                        [name]: {
                                          document_name: onlyAlphaNum,
                                        },
                                      },
                                    });
                                  }}
                                />
                              </Form.Item>
                            );
                          }}
                        </Form.Item>
                      </Col>

                      {/* Upload Document */}
                      <Col span={8}>
                        <Form.Item
                          name={[name, "attachments"]}
                          label="Upload Document (PDF only)"
                          rules={[
                            {
                              required: true,
                              message: "Please upload a document",
                            },
                          ]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) =>
                            Array.isArray(e) ? e : e?.fileList
                          }
                        >
                          <Upload
                            beforeUpload={(file) => {
                              const isPdf = file.type === "application/pdf";
                              if (!isPdf) {
                                Modal.error({
                                  title: "Invalid File Type",
                                  content: "Only PDF files are allowed!",
                                });
                                return Upload.LIST_IGNORE;
                              }
                              return false; // prevent auto-upload
                            }}
                            maxCount={1}
                            style={{ width: "80%" }}
                          >
                            <Button
                              icon={<UploadOutlined />}
                              block
                              style={{
                                height: "80px",
                                fontSize: "16px",
                              }}
                            >
                              Upload PDF
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>

                      {/* Remove Button */}
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Row>
                  ))}
                </div>
              )}
            </Form.List>


            <Form.Item shouldUpdate noStyle>
              {(form) => (
                <div style={{
                  background: "#f5f5f5",
                  width: "99%",
                  margin: "0 auto 20px auto",
                  padding: "24px 8px",
                  borderRadius: "6px",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}>
                  <Row
                    gutter={16}
                    style={{
                      margin: 0,
                      alignItems: "center",
                    }}
                  >
                    <Col span={12}>
                      <span><h4 style={{ margin: "10px 0 10px 0", padding: 0 }}>SMS Master </h4></span>
                    </Col>

                    <Col span={12} style={{ textAlign: "right" }}>
                      <Button
                        type="text"
                        size="small"
                        icon={smsCollapsed ? <CaretUpOutlined /> : <CaretDownOutlined />}
                        onClick={() => setSmsCollapsed(!smsCollapsed)}
                      >
                        {smsCollapsed ? "Hide" : "Add"}
                      </Button>
                    </Col>
                  </Row>
                  {/* SMS Details block */}
                  {smsCollapsed && (
                    <div
                      style={{
                        background: "#f5f5f5",
                        borderRadius: "6px",
                        marginTop: 16,
                        position: "relative",
                      }}
                    >
                      <Row gutter={16}>
                        {/* SMS */}
                       

                      </Row>

                    </div>
                  )}
                </div>
              )}
            </Form.Item>


            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginTop: 16 }}
                >
                  {isEditMode ? "Update" : "Add"}
                </Button>
              </Form.Item>
            </div>
          </>
        </Form>
      </Modal>

      <Modal
        visible={previewOpen}
        title={previewTitle}
        footer={null}
        centered
        onCancel={() => setPreviewOpen(false)}
      >
        <img
          alt="Preview"
          style={{ width: '100%' }}
          src={previewImage}
        />
      </Modal>
    </>
  );
};

export default LedgerModal;
